<template>
  <div class="upsert-order">
    <KTCodePreview v-bind:title="''">
      <template v-slot:preview>
        <b-card no-body class="full-width">
          <!-- <div class="wizard-nav-bg">
            <b-col
              class="py-2 mb-1"
              cols="12"
              style="border-bottom: 0.5px solid #e7e7e7"
            >
              <b-skeleton-wrapper :loading="!loadingComponent">
                <template #loading>
                  <b-row>
                    <b-col cols="3">
                      <div class="d-flex d-inline">
                        <b-skeleton type="avatar"></b-skeleton>
                        <div class="w-100 pl-2">
                          <b-skeleton width="30%"></b-skeleton>
                          <b-skeleton width="50%"></b-skeleton>
                        </div>
                      </div>
                    </b-col>
                    <b-col cols="9" class="text-center align-self-center">
                      <b-skeleton width="70%"></b-skeleton>
                    </b-col>
                  </b-row>
                </template>
                <OrderHeader
                  :entity="orderInfo"
                  :userInfor="userInfor"
                  :action="action"
                  typeHeader="order-upsert"
                  v-if="loadingComponent"
                />
              </b-skeleton-wrapper>
            </b-col>
          </div> -->
          <div
            class="wizard wizard-4"
            id="kt_wizard_v4_2"
            data-wizard-state="step-first"
            data-wizard-clickable="true"
          >
            <div class="wizard-nav wizard-nav-bg" style="border-radius: 0px">
              <div class="wizard-steps">
                <div
                  class="wizard-step mb-0"
                  data-wizard-type="step"
                  data-wizard-state="current"
                >
                  <div class="wizard-wrapper p-2">
                    <div class="wizard-label">
                      <div class="wizard-title">Thông tin</div>
                    </div>
                  </div>
                </div>
                <!-- <div class="wizard-step ml-1 mb-0" data-wizard-type="step">
                  <div class="wizard-wrapper p-2">
                    <div class="wizard-label">
                      <div class="wizard-title">Sản phẩm</div>
                    </div>
                  </div>
                </div> -->
                <!-- <div
                  class="wizard-step ml-1 mb-0"
                  data-wizard-type="step"
                  v-if="orderId"
                >
                  <div class="wizard-wrapper p-2">
                    <div class="wizard-label">
                      <div class="wizard-title">Bút toán</div>
                    </div>
                  </div>
                </div>
                <div
                  class="wizard-step ml-1 mb-0"
                  data-wizard-type="step"
                  v-if="orderId"
                >
                  <div class="wizard-wrapper p-2">
                    <div class="wizard-label">
                      <div class="wizard-title">Lịch sử</div>
                    </div>
                  </div>
                </div> -->
                <div class="wizard-step ml-1 mb-0" data-wizard-type="step">
                  <div class="wizard-wrapper p-2">
                    <div class="wizard-label">
                      <div class="wizard-title">Lịch sử thao tác</div>
                    </div>
                  </div>
                </div>
                <div class="wizard-step ml-1 mb-0" data-wizard-type="step">
                  <div class="wizard-wrapper p-2">
                    <div class="wizard-label">
                      <div class="wizard-title">Đính kèm</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card card-custom card-shadowless rounded-top-0">
              <div class="card-body p-0">
                <b-row class="py-8">
                  <b-col cols="12">
                    <div
                      class="pb-5 full-width"
                      data-wizard-type="step-content"
                      data-wizard-state="current"
                    >
                      <!-- <b-container>
                        <b-row class="col-md-12 mb-1 m-0 p-0" v-if="preOrderId">
                          <b-alert
                            show
                            variant="warning"
                            style="
                              background-color: #fff3db;
                              border-color: #ffecc7;
                            "
                            class="w-100"
                          >
                            <i
                              class="fa fa-exclamation-triangle text-warning"
                            ></i>
                            <strong class="text-dark">
                              Đơn hàng được tạo từ đơn hàng đặt trước:</strong
                            >
                            <b
                              class="text-primary orderCode"
                              @click="linkToPreOrder(preOrderId)"
                              style="cursor: pointer"
                            >
                              {{ preOrderId }}
                            </b>
                          </b-alert>
                        </b-row>
                        <b-row
                          class="col-md-12 mb-1 m-0 p-0"
                          v-if="orderCampainPhase"
                        >
                          <b-alert
                            show
                            variant="warning"
                            style="
                              background-color: #fff3db;
                              border-color: #ffecc7;
                            "
                            class="w-100"
                          >
                            <i
                              class="fa fa-exclamation-triangle text-warning"
                            ></i>
                            <b class="text-warning orderCode">
                              {{ orderCampainPhase }}
                            </b>
                          </b-alert>
                        </b-row>
                      </b-container> -->
                      <!-- <b-container>
                        <b-row
                          class="col-md-12 mb-1 m-0 p-0"
                          v-if="!userInfor.jobTitleId"
                        >
                          <b-alert
                            show
                            variant="danger"
                            style="
                              background-color: #ffffff;
                              border-color: #efefef;
                            "
                            class="w-100"
                          >
                            <i
                              class="fa fa-exclamation-triangle text-warning"
                            ></i>
                            <strong class="text-danger">
                              Tài khoản chưa được gán chức vụ, vui lòng liên hệ
                              admin để xử lí</strong
                            >
                          </b-alert>
                        </b-row>
                      </b-container> -->
                      <b-container class="bv-example-row">
                        <!-- ============================================
                             Sprint 3 enhancement — HĐ V2 features:
                             - Banner Đề nghị nguồn (link 2 chiều)
                             - Status badge + action buttons (Hủy / Override price)
                             - Snapshot pháp lý KH (read-only collapse)
                             ============================================ -->
                        <!-- ===== Stepper 9 bước — luồng duyệt HĐMB ===== -->
                        <div
                          v-if="loadingComponent && contractInfo.status"
                          class="contract-stepper mb-4"
                          :class="{
                            'is-cancelled': contractInfo.status === 'cancelled',
                          }"
                        >
                          <div
                            v-for="(st, i) in stepperStates"
                            :key="st"
                            class="contract-step"
                            :class="stepClass(st)"
                          >
                            <div class="contract-step-dot">
                              <i
                                v-if="stepClass(st) === 'is-done'"
                                class="fas fa-check"
                              ></i>
                              <span v-else>{{ i + 1 }}</span>
                            </div>
                            <div class="contract-step-label">
                              {{ contractStatusLabel(st) }}
                            </div>
                            <div
                              v-if="stepActorMap[st]"
                              class="contract-step-actor"
                              :title="
                                stepActorMap[st].at
                                  ? formatHistoryTime(stepActorMap[st].at)
                                  : ''
                              "
                            >
                              {{ stepActorMap[st].name
                              }}<template v-if="stepActorMap[st].code">
                                ({{ stepActorMap[st].code }})</template
                              >
                            </div>
                          </div>
                          <div
                            v-if="contractInfo.status === 'cancelled'"
                            class="contract-step is-cancelled-step"
                          >
                            <div class="contract-step-dot">
                              <i class="fas fa-times"></i>
                            </div>
                            <div class="contract-step-label">Đã hủy</div>
                            <div
                              v-if="cancelledActor"
                              class="contract-step-actor"
                              :title="
                                cancelledActor.at
                                  ? formatHistoryTime(cancelledActor.at)
                                  : ''
                              "
                            >
                              {{ cancelledActor.name
                              }}<template v-if="cancelledActor.code">
                                ({{ cancelledActor.code }})</template
                              >
                            </div>
                          </div>
                        </div>

                        <b-row
                          v-if="
                            loadingComponent &&
                            (contractInfo.contractRequestId ||
                              contractInfo.status)
                          "
                          class="mb-3 align-items-center"
                        >
                          <b-col cols="auto" v-if="contractInfo.status">
                            <b><i class="fas fa-flag mr-1"></i>Trạng thái:</b>
                            <b-badge
                              class="ml-1"
                              :variant="
                                contractStatusVariant(contractInfo.status)
                              "
                              style="font-size: 13px; padding: 6px 10px"
                            >
                              {{ contractStatusLabel(contractInfo.status) }}
                            </b-badge>
                          </b-col>
                          <b-col v-if="contractInfo.contractRequestId">
                            <b
                              ><i class="fas fa-link mr-1"></i>Đề nghị nguồn:</b
                            >
                            <span
                              class="ml-1 cr-linked-request"
                              @click="
                                goToContractRequest(
                                  contractInfo.contractRequestId,
                                )
                              "
                            >
                              {{
                                (contractInfo.contractRequest &&
                                  contractInfo.contractRequest.code) ||
                                contractInfo.contractRequestId
                              }}
                              <i class="fas fa-external-link-alt ml-1"></i>
                            </span>
                          </b-col>
                          <b-col cols="auto" class="text-right ml-auto">
                            <!-- Nút bước kế tiếp (state machine) -->
                            <b-button
                              v-for="ns in nextTransitions"
                              :key="ns"
                              size="sm"
                              variant="primary"
                              class="mr-2 mb-1"
                              @click="openTransitionDialog(ns)"
                            >
                              <i class="fas fa-arrow-right mr-1"></i>
                              {{ transitionActionLabel(ns) }}
                            </b-button>
                            <!-- Tạo hóa đơn — HĐ đã phân bổ xe (giống nút ở danh sách). -->
                            <b-button
                              v-if="contractInfo.status === 'allocated'"
                              size="sm"
                              variant="success"
                              class="mr-2 mb-1"
                              @click="createBill"
                            >
                              <i class="fas fa-file-invoice mr-1"></i>
                              Tạo hóa đơn
                            </b-button>
                            <b-button
                              v-if="canOverridePrice"
                              size="sm"
                              variant="outline-warning"
                              class="mr-2 mb-1"
                              v-b-tooltip.hover
                              title="Sửa giá item (audit PRICE_OVERRIDE)"
                              @click="openOverridePriceDialog"
                            >
                              <i class="fas fa-edit"></i>
                              Sửa giá item
                            </b-button>
                            <b-button
                              v-if="contractInfo.status === 'allocated'"
                              size="sm"
                              variant="outline-warning"
                              class="mr-2 mb-1"
                              @click="openUnallocateDialog"
                            >
                              <i class="fas fa-unlink mr-1"></i>
                              Gỡ xe / Hủy ghép
                            </b-button>
                            <b-button
                              v-if="canExportDocx"
                              size="sm"
                              variant="primary"
                              class="mr-2 mb-1"
                              :disabled="exportingDocx"
                              @click="handleExportDocx"
                            >
                              <b-spinner
                                v-if="exportingDocx"
                                small
                                class="mr-1"
                              />
                              <i v-else class="far fa-file-word mr-1"></i>
                              Xuất file Word
                            </b-button>
                            <b-button
                              v-if="canCancelContract"
                              size="sm"
                              variant="outline-danger"
                              class="mb-1"
                              @click="cancelDialog.show = true"
                            >
                              <i class="fas fa-ban"></i>
                              Hủy HĐ
                            </b-button>
                          </b-col>
                        </b-row>

                        <!-- HĐ đã hủy → hiện rõ lý do (cancelReason). BE lưu ở
                             contract.cancelReason khi transition → cancelled;
                             trước đây chỉ nằm trong tab Lịch sử nên user không thấy. -->
                        <b-alert
                          v-if="
                            contractInfo.status === 'cancelled' &&
                            contractInfo.cancelReason
                          "
                          variant="danger"
                          show
                          class="cr-cancel-reason mb-3"
                        >
                          <i class="fas fa-ban mr-1"></i>
                          <b>Lý do hủy hợp đồng:</b>
                          {{ contractInfo.cancelReason }}
                        </b-alert>

                        <!-- HĐ vừa gỡ xe (allocated → deposited) → hiện rõ lý do gỡ.
                             Lý do nằm trong ContractHistory (computed unallocateReason),
                             trước đây chỉ thấy ở tab Lịch sử. -->
                        <b-alert
                          v-if="unallocateReason"
                          variant="warning"
                          show
                          class="cr-cancel-reason mb-3"
                        >
                          <i class="fas fa-unlink mr-1"></i>
                          <b>Lý do gỡ xe gần nhất:</b>
                          {{ unallocateReason }}
                        </b-alert>

                        <!-- Cảnh báo HĐ có phiếu báo có chưa nhập mã tham chiếu
                             (mã tham chiếu không còn bắt buộc khi tạo phiếu). -->
                        <b-alert
                          v-if="hasMissingPaymentCode"
                          variant="warning"
                          show
                          class="cr-cancel-reason mb-3"
                        >
                          <i class="fas fa-exclamation-triangle mr-1"></i>
                          <b>Chưa nhập mã tham chiếu:</b>
                          Hợp đồng có phiếu báo có (chuyển khoản) chưa nhập mã
                          tham chiếu — vui lòng bổ sung.
                        </b-alert>

                        <!-- ===== Thông tin khách hàng — component dùng chung.
                             create (HĐMB trực tiếp): editable + search KH theo SĐT.
                             update + tạo trực tiếp: vẫn cho sửa snapshot KH.
                             update + tạo từ Đề Nghị: read-only (bất biến). ===== -->
                        <CustomerInfoSection
                          v-if="loadingComponent"
                          :customer="contractInfo"
                          :disabled="isCustomerLocked"
                          :appellation-options="appellationOptions"
                          :customer-type-options="customerTypeOptions"
                          :dp-config="dpConfigs.date"
                          editable-type
                          :disabled-type="isCustomerLocked"
                          show-required
                        >
                          <template #phone-customer>
                            <Autosuggest
                              :model="contractInfo.customerPhone"
                              :suggestions="filteredCustomerOptions"
                              :suggestionName="'phoneNumber'"
                              placeholder="số điện thoại"
                              :limit="10"
                              :disabled="isCustomerLocked"
                              @select="onSelectCustomer"
                              @change="onSearchCustomerChange"
                            >
                              <template #custom="{ suggestion }">
                                <div class="d-flex flex-column">
                                  <span
                                    v-if="suggestion.item.phoneNumber"
                                    class="text-primary mb-1"
                                    >({{ suggestion.item.phoneNumber }})</span
                                  >
                                  <span v-if="suggestion.item.fullName">{{
                                    suggestion.item.fullName
                                  }}</span>
                                  <span v-else class="text-muted">{{
                                    suggestion.item.message
                                  }}</span>
                                </div>
                              </template>
                            </Autosuggest>
                          </template>
                          <template #mst-business>
                            <Autosuggest
                              :model="businessTaxNoInput"
                              :suggestions="filteredBusinessOptions"
                              :suggestionName="'taxNo'"
                              placeholder="Mã số thuế"
                              :limit="10"
                              @select="onSelectBusiness"
                              @change="onSearchBusinessChange"
                            >
                              <template #custom="{ suggestion }">
                                <div class="d-flex flex-column">
                                  <span
                                    v-if="suggestion.item.taxNo"
                                    class="text-primary mb-1"
                                    >({{ suggestion.item.taxNo }})</span
                                  >
                                  <span v-if="suggestion.item.name">{{
                                    suggestion.item.name
                                  }}</span>
                                  <span v-else class="text-muted">{{
                                    suggestion.item.message
                                  }}</span>
                                </div>
                              </template>
                            </Autosuggest>
                          </template>
                        </CustomerInfoSection>
                        <hr v-if="loadingComponent" class="mt-3 mb-4" />

                        <b-skeleton-wrapper :loading="!loadingComponent">
                          <b-row>
                            <!-- <b-col>
                              <OrderInfo
                                :data="orderInfo"
                                v-if="loadingComponent"
                                :action="action"
                              />
                            </b-col> -->
                            <b-col>
                              <ContractInfo
                                v-if="loadingComponent"
                                :action="action"
                                :contractData="contractInfo"
                                :isDisabled="isDisabled"
                              />
                            </b-col>
                            <!-- CustomerInfo col đã chuyển ra section full-width
                                 "Thông tin khách hàng" phía trên. -->

                            <b-col>
                              <EmployeeInfo
                                v-if="loadingComponent"
                                :storeId="contractInfo.storeId"
                                :contractDataEmployeeInfo="contractEmployeeInfo"
                                :contractData="contractInfo"
                                :action="action"
                                :isDisabled="isDisabled"
                              />
                            </b-col>

                            <b-col>
                              <Discount
                                v-if="loadingComponent"
                                :contractData="contractInfo"
                                :action="action"
                                :isDisabled="isDisabled"
                              />
                            </b-col>

                            <!-- <b-col>
                              <OrderNote
                                v-if="loadingComponent"
                                :action="action"
                              />
                            </b-col> -->
                            <!-- <b-col>
                              <OrderDiscount
                                v-if="loadingComponent"
                                :action="action"
                              />
                            </b-col> -->
                            <!-- <b-col>
                              <BillPayment
                                ref="bill-payment"
                                :finalAmount="totalAmount"
                                :billData="orderFinal"
                                :onSubmiting="false"
                                :fromOrder="fromOrder"
                                :subtractPointAmount="
                                  orderDiscount.subtractPointAmount
                                "
                                :action="action"
                                :isAllowQRCode="isAllowQRCode"
                                v-if="loadingComponent"
                                v-on:receive-payment="onReceivePayment"
                                v-on:receive-payment-mul="onReceivePaymentMul"
                                v-on:click-generate-qrcode="onClickGenerateQR"
                              />
                            </b-col> -->
                          </b-row>
                          <template #loading>
                            <b-row>
                              <b-col>
                                <div>
                                  <b-skeleton width="50%"></b-skeleton>
                                  <b-skeleton></b-skeleton>
                                </div>
                                <div class="mt-4">
                                  <b-skeleton width="50%"></b-skeleton>
                                  <b-skeleton></b-skeleton>
                                </div>
                                <div class="mt-4">
                                  <b-skeleton width="50%"></b-skeleton>
                                  <b-skeleton></b-skeleton>
                                </div>
                                <div class="mt-4">
                                  <b-skeleton width="50%"></b-skeleton>
                                  <b-skeleton></b-skeleton>
                                </div>
                                <div class="mt-4">
                                  <b-skeleton width="50%"></b-skeleton>
                                  <b-skeleton></b-skeleton>
                                </div>
                                <div class="mt-4">
                                  <b-skeleton width="50%"></b-skeleton>
                                  <b-skeleton></b-skeleton>
                                </div>
                                <div class="mt-4">
                                  <b-skeleton width="50%"></b-skeleton>
                                  <b-skeleton></b-skeleton>
                                </div>
                                <div class="mt-4">
                                  <b-skeleton width="50%"></b-skeleton>
                                  <b-skeleton></b-skeleton>
                                </div>
                              </b-col>
                              <b-col>
                                <div>
                                  <b-skeleton width="50%"></b-skeleton>
                                  <b-skeleton></b-skeleton>
                                </div>
                                <div class="mt-4">
                                  <b-skeleton width="50%"></b-skeleton>
                                  <b-skeleton></b-skeleton>
                                </div>
                                <div class="mt-4">
                                  <b-skeleton width="50%"></b-skeleton>
                                  <b-skeleton></b-skeleton>
                                </div>
                                <div class="mt-4">
                                  <b-skeleton width="50%"></b-skeleton>
                                  <b-skeleton></b-skeleton>
                                </div>
                                <div class="mt-4">
                                  <b-skeleton width="50%"></b-skeleton>
                                  <b-skeleton></b-skeleton>
                                </div>
                                <div class="mt-4">
                                  <b-skeleton width="50%"></b-skeleton>
                                  <b-skeleton></b-skeleton>
                                </div>
                                <div class="mt-4">
                                  <b-skeleton width="50%"></b-skeleton>
                                  <b-skeleton></b-skeleton>
                                </div>
                                <div class="mt-4">
                                  <b-skeleton width="50%"></b-skeleton>
                                  <b-skeleton></b-skeleton>
                                </div>
                              </b-col>
                              <b-col>
                                <div>
                                  <b-skeleton width="50%"></b-skeleton>
                                  <b-skeleton></b-skeleton>
                                </div>
                                <div class="mt-4">
                                  <b-skeleton width="50%"></b-skeleton>
                                  <b-skeleton></b-skeleton>
                                </div>
                                <div class="mt-4">
                                  <b-skeleton width="50%"></b-skeleton>
                                  <b-skeleton></b-skeleton>
                                </div>
                                <div class="mt-4">
                                  <b-skeleton width="50%"></b-skeleton>
                                  <b-skeleton></b-skeleton>
                                </div>
                                <div class="mt-4">
                                  <b-skeleton width="50%"></b-skeleton>
                                  <b-skeleton></b-skeleton>
                                </div>
                                <div class="mt-4">
                                  <b-skeleton width="50%"></b-skeleton>
                                  <b-skeleton></b-skeleton>
                                </div>
                                <div class="mt-4">
                                  <b-skeleton width="50%"></b-skeleton>
                                  <b-skeleton></b-skeleton>
                                </div>
                                <div class="mt-4">
                                  <b-skeleton width="50%"></b-skeleton>
                                  <b-skeleton></b-skeleton>
                                </div>
                              </b-col>
                              <b-col>
                                <div>
                                  <b-skeleton width="50%"></b-skeleton>
                                  <b-skeleton></b-skeleton>
                                </div>
                                <div class="mt-4">
                                  <b-skeleton width="50%"></b-skeleton>
                                  <b-skeleton></b-skeleton>
                                </div>
                                <div class="mt-4">
                                  <b-skeleton width="50%"></b-skeleton>
                                  <b-skeleton></b-skeleton>
                                </div>
                                <div class="mt-4">
                                  <b-skeleton width="50%"></b-skeleton>
                                  <b-skeleton></b-skeleton>
                                </div>
                                <div class="mt-4">
                                  <b-skeleton width="50%"></b-skeleton>
                                  <b-skeleton></b-skeleton>
                                </div>
                                <div class="mt-4">
                                  <b-skeleton width="50%"></b-skeleton>
                                  <b-skeleton></b-skeleton>
                                </div>
                                <div class="mt-4">
                                  <b-skeleton width="50%"></b-skeleton>
                                  <b-skeleton></b-skeleton>
                                </div>
                                <div class="mt-4">
                                  <b-skeleton width="50%"></b-skeleton>
                                  <b-skeleton></b-skeleton>
                                </div>
                              </b-col>
                              <b-col>
                                <div>
                                  <b-skeleton width="50%"></b-skeleton>
                                  <b-skeleton></b-skeleton>
                                </div>
                                <div class="mt-4">
                                  <b-skeleton width="50%"></b-skeleton>
                                  <b-skeleton></b-skeleton>
                                </div>
                                <div class="mt-4">
                                  <b-skeleton width="50%"></b-skeleton>
                                  <b-skeleton></b-skeleton>
                                </div>
                                <div class="mt-4">
                                  <b-skeleton width="50%"></b-skeleton>
                                  <b-skeleton></b-skeleton>
                                </div>
                                <div class="mt-4">
                                  <b-skeleton width="50%"></b-skeleton>
                                  <b-skeleton></b-skeleton>
                                </div>
                                <div class="mt-4">
                                  <b-skeleton width="50%"></b-skeleton>
                                  <b-skeleton></b-skeleton>
                                </div>
                                <div class="mt-4">
                                  <b-skeleton width="50%"></b-skeleton>
                                  <b-skeleton></b-skeleton>
                                </div>
                                <div class="mt-4">
                                  <b-skeleton width="50%"></b-skeleton>
                                  <b-skeleton></b-skeleton>
                                </div>
                              </b-col>
                            </b-row>
                          </template>
                        </b-skeleton-wrapper>

                        <hr
                          class="hr-text"
                          data-content="Thông tin sản phẩm"
                          style="font-weight: 600"
                        />
                        <div class="mt-2" v-if="!onChangeProductTab">
                          <b-skeleton-wrapper :loading="!loadingComponent">
                            <template #loading>
                              <b-skeleton-table
                                :rows="5"
                                :columns="4"
                                :table-props="{ bordered: true, striped: true }"
                              ></b-skeleton-table>
                            </template>

                            <ProductTable
                              :editable="true"
                              :isDisabled="isDisabled"
                              :contractData="contractInfo"
                              v-if="loadingComponent"
                            />
                          </b-skeleton-wrapper>

                          <hr
                            class="hr-text"
                            data-content="Điều khoản thanh toán"
                            style="font-weight: 600"
                            v-if="contractInfo"
                          />

                          <PaymentTerm
                            :contractData="contractInfo"
                            v-if="contractInfo"
                            :isDisabled="isDisabled"
                            @add-receipt="onAddReceiptForTerm"
                            @fetch-contract="fetchContract"
                          ></PaymentTerm>

                          <hr
                            class="hr-text"
                            data-content="Bút Toán"
                            style="font-weight: 600"
                          />

                          <b-row>
                            <b-col md="12" lg="12" sm="12">
                              <ContractTransaction
                                ref="contractTransactionRef"
                                :contractId="contractInfo.id"
                              />
                            </b-col>
                          </b-row>

                          <!-- <OrderTransactions
                            :orderNumber="orderId"
                            v-if="orderId"
                          />
                          <div v-if="false">
                            <code class="mt-4 d-block">
                              {{ orderInfo ? Object.values(orderInfo) : [] }}
                            </code>
                            <code class="mt-4 d-block">
                              {{
                                orderCustomerInfo
                                  ? Object.values(orderCustomerInfo)
                                  : []
                              }}
                            </code>
                            <code class="mt-4 d-block">
                              {{
                                orderDiscount
                                  ? Object.values(orderDiscount)
                                  : []
                              }}
                            </code>
                            <code class="mt-4 d-block">
                              {{ orderNote ? Object.values(orderNote) : [] }}
                            </code>
                            <code class="mt-4 d-block">
                              {{ orderItems || [] }}
                            </code>
                          </div> -->
                        </div>
                      </b-container>
                    </div>
                    <!-- ===== Tab: Lịch sử thao tác hợp đồng (audit) ===== -->
                    <div
                      class="pb-5 full-width"
                      data-wizard-type="step-content"
                    >
                      <b-container class="bv-example-row">
                        <b-row>
                          <b-col cols="12">
                            <div
                              class="d-flex justify-content-between align-items-center mb-3"
                            >
                              <h6 class="mb-0">
                                <i class="fas fa-history mr-2"></i>Lịch sử thao
                                tác hợp đồng
                              </h6>
                              <b-button
                                size="sm"
                                variant="outline-secondary"
                                @click="loadContractHistory"
                              >
                                <i class="fas fa-sync-alt mr-1"></i>Tải lại
                              </b-button>
                            </div>
                            <b-table
                              :items="contractHistory"
                              :fields="[
                                { key: 'changedAt', label: 'Thời gian' },
                                { key: 'user', label: 'Người thực hiện' },
                                { key: 'action', label: 'Hành động' },
                                { key: 'detail', label: 'Chi tiết' },
                              ]"
                              small
                              responsive
                              head-variant="light"
                              show-empty
                              empty-text="Chưa có lịch sử thao tác"
                              class="mb-0"
                            >
                              <template #cell(changedAt)="{ item }">
                                {{ formatHistoryTime(item.changedAt) }}
                              </template>
                              <template #cell(user)="{ item }">
                                {{ historyUserName(item) }}
                              </template>
                              <template #cell(action)="{ item }">
                                <b-badge variant="light" class="border">
                                  {{ historyActionLabel(item.action) }}
                                </b-badge>
                              </template>
                              <template #cell(detail)="{ item }">
                                {{ historyDetail(item) }}
                              </template>
                            </b-table>
                          </b-col>
                        </b-row>
                      </b-container>
                    </div>
                    <!-- <div
                      class="pb-5 full-width"
                      data-wizard-type="step-content"
                    >
                      <b-container
                        class="bv-example-row"
                        v-if="onChangeProductTab"
                      >
                        <ProductTable
                          :editable="true"
                          v-if="loadingComponent"
                        />
                      </b-container>
                    </div>
                    <div
                      class="pb-5 full-width"
                      data-wizard-type="step-content"
                      v-if="orderId"
                    >
                      <b-container class="bv-example-row">
                        <OrderTransactions :orderNumber="orderId" />
                      </b-container>
                    </div>
                    <div
                      class="pb-5 full-width"
                      data-wizard-type="step-content"
                      v-if="orderId"
                    >
                      <b-container class="bv-example-row">
                        <b-row></b-row>
                      </b-container>
                    </div> -->
                    <div
                      class="pb-5 full-width"
                      data-wizard-type="step-content"
                    >
                      <b-container class="bv-example-row">
                        <b-row>
                          <div class="w-100">
                            <UploadFile
                              :id="contractInfo.id"
                              :entity="'contracts'"
                            />
                          </div>
                        </b-row>
                      </b-container>
                    </div>
                  </b-col>
                </b-row>
              </div>
            </div>
          </div>
          <template #footer>
            <!-- <b-dropdown
                size="sm"
                split
                variant="primary"
                class="mr-3"
                @click="upsertOrder"
              >
                <template v-slot:button-content>
                  <div class="font-weight-bolder" style="width: 4rem">
                    <span v-if="action === 'create'">Tạo mới</span
                    ><span v-else-if="action === 'update'">Cập nhật</span>
                  </div>
                </template>
                <b-dropdown-item-button @click="onContinueCreateOrder"
                  >Lưu và tiếp tục tạo đơn</b-dropdown-item-button
                >
              </b-dropdown> -->
            <b-button
              v-if="
                !isApproved &&
                !isConfirm &&
                !contractInfo.bill &&
                !['cancelled', 'invoiced'].includes(contractInfo.status)
              "
              class="font-weight-bolder mr-4"
              size="sm"
              variant="primary"
              style="width: 80px"
              @click="debounceUpsertOrder"
              :disabled="!loadingComponent"
            >
              <span v-if="action === 'create'">Tạo mới</span
              ><span v-else-if="action === 'update'">Cập nhật</span></b-button
            >
            <b-button
              v-else-if="
                isApproved && !contractInfo.approveBy && !contractInfo.confirmBy
              "
              class="font-weight-bolder mr-4"
              size="sm"
              variant="primary"
              style="width: 80px"
              @click="debounceApproveContract"
              :disabled="!loadingComponent"
            >
              <span>Duyệt</span></b-button
            >
            <b-button
              v-else-if="
                isConfirm && contractInfo.approveBy && !contractInfo.confirmBy
              "
              class="font-weight-bolder mr-4"
              size="sm"
              variant="primary"
              style="width: 110px"
              @click="debounceConfirmContract"
              :disabled="!loadingComponent"
            >
              <span>Duyệt giữ hàng</span></b-button
            >
            <b-button
              class="font-weight-bolder"
              size="sm"
              variant="secondary"
              style="width: 80px"
              @click="onCloseOrder"
              >Huỷ</b-button
            >
          </template>
        </b-card>

        <QRCodeModal
          ref="qr-code-modal"
          :qrCode="qrCode"
          :billNumber="orderId"
          :type="REFERENCE_TYPE.ORDER"
          :transferAmount="transferAmount"
          :payment="qrCodePaymentInfo"
          @onGenerateQR="onGenerateQR"
          @afterGenerateQR="afterGenerateQR"
        />
        <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
      </template>
    </KTCodePreview>

    <!-- Modal: Tạo phiếu thu / phiếu báo có cho 1 đợt thanh toán -->
    <DownPaymentForm ref="downPaymentForm" @fetchContract="fetchContract" />

    <!-- Modal: Transition state (luồng duyệt HĐMB) -->
    <b-modal
      v-model="transitionDialog.show"
      :title="transitionActionLabel(transitionDialog.toStatus)"
      hide-footer
      no-close-on-backdrop
    >
      <p>
        Xác nhận chuyển hợp đồng sang trạng thái
        <b>{{ contractStatusLabel(transitionDialog.toStatus) }}</b
        >?
      </p>
      <b-alert
        v-if="transitionDialog.toStatus === 'signed'"
        variant="info"
        show
      >
        <i class="fas fa-info-circle mr-1"></i>
        Tương đương DUYỆT HỢP ĐỒNG — hệ thống ghi nhận người duyệt (approveBy).
      </b-alert>
      <b-alert
        v-if="transitionDialog.toStatus === 'deposited'"
        variant="info"
        show
      >
        <i class="fas fa-info-circle mr-1"></i>
        Cần đã ghi nhận phiếu thu / báo có (tiền cọc) — nếu chưa có, hệ thống sẽ
        báo lỗi.
      </b-alert>
      <b-alert
        v-if="transitionDialog.toStatus === 'allocated'"
        variant="info"
        show
      >
        <i class="fas fa-info-circle mr-1"></i>
        Tương đương DUYỆT GIỮ HÀNG — kiểm tra đã phân bổ số khung/số máy/seri,
        giữ tồn kho. Sau bước này HĐ đủ điều kiện tạo hóa đơn.
      </b-alert>
      <div v-if="transitionDialog.error" class="text-danger small mb-2">
        {{ transitionDialog.error }}
      </div>
      <div class="d-flex justify-content-end mt-3">
        <b-button
          class="mr-2"
          size="sm"
          variant="secondary"
          :disabled="transitionDialog.submitting"
          @click="transitionDialog.show = false"
        >
          Đóng
        </b-button>
        <b-button
          size="sm"
          variant="primary"
          :disabled="transitionDialog.submitting"
          @click="onSubmitTransition"
        >
          Xác nhận
        </b-button>
      </div>
    </b-modal>

    <!-- Modal: Cancel HĐ (BE-026) -->
    <b-modal
      v-model="cancelDialog.show"
      title="Hủy hợp đồng"
      hide-footer
      no-close-on-backdrop
    >
      <b-form-group>
        <label
          >Lý do hủy <b class="text-danger">*</b> (tối thiểu 10 ký tự):</label
        >
        <b-form-textarea
          v-model="cancelDialog.reason"
          size="sm"
          :rows="3"
          placeholder="Nhập lý do hủy"
          :state="cancelDialog.error ? false : null"
        />
        <b-form-invalid-feedback :state="!cancelDialog.error">
          {{ cancelDialog.error }}
        </b-form-invalid-feedback>
      </b-form-group>
      <b-alert v-if="contractInfo.status === 'paid'" variant="warning" show>
        <i class="fas fa-exclamation-triangle mr-1"></i>
        HĐ đã thanh toán — KTT cần xử lý hoàn tiền sau khi hủy.
      </b-alert>
      <div class="d-flex justify-content-end mt-3">
        <b-button
          class="mr-2"
          size="sm"
          variant="secondary"
          :disabled="cancelDialog.submitting"
          @click="cancelDialog.show = false"
        >
          Đóng
        </b-button>
        <b-button
          size="sm"
          variant="danger"
          :disabled="cancelDialog.submitting"
          @click="onSubmitCancelContract"
        >
          Xác nhận hủy
        </b-button>
      </div>
    </b-modal>

    <!-- Modal: Gỡ xe / Hủy ghép (allocated → deposited, KHÔNG hủy HĐ) -->
    <b-modal
      v-model="unallocateDialog.show"
      title="Gỡ xe / Hủy ghép"
      hide-footer
      no-close-on-backdrop
    >
      <b-alert variant="info" show class="cr-unallocate-note">
        <i class="fas fa-info-circle mr-1"></i>
        HĐ sẽ về <b>Đã đặt cọc</b> — KHÔNG hủy hợp đồng. Tồn kho được hoàn, xe
        được gỡ; có thể ghép xe khác sau.
      </b-alert>
      <b-form-group>
        <label>Lý do <b class="text-danger">*</b></label>
        <b-form-select
          v-model="unallocateDialog.reasonCategory"
          :options="unallocateReasonOptions"
          size="sm"
        >
          <template #first>
            <b-form-select-option :value="null" disabled>
              -- Chọn lý do --
            </b-form-select-option>
          </template>
        </b-form-select>
      </b-form-group>
      <!-- Ghi chú CHỈ hiện/bắt buộc khi lý do = "Khác" (đồng bộ BE
           UnallocateContractDto). Lý do preset → nhãn đã đủ ngữ cảnh. -->
      <b-form-group v-if="isUnallocateOther">
        <label
          >Ghi chú <b class="text-danger">*</b> (tối thiểu 10 ký tự):</label
        >
        <b-form-textarea
          v-model="unallocateDialog.note"
          size="sm"
          :rows="3"
          placeholder="Mô tả cụ thể lý do khác..."
          :state="unallocateDialog.error ? false : null"
        />
      </b-form-group>
      <b-alert
        v-if="unallocateDialog.error"
        variant="danger"
        show
        class="py-1 px-2 mb-0"
      >
        {{ unallocateDialog.error }}
      </b-alert>
      <div class="d-flex justify-content-end mt-3">
        <b-button
          class="mr-2"
          size="sm"
          variant="secondary"
          :disabled="unallocateDialog.submitting"
          @click="unallocateDialog.show = false"
        >
          Đóng
        </b-button>
        <b-button
          size="sm"
          variant="warning"
          :disabled="unallocateDialog.submitting"
          @click="onSubmitUnallocate"
        >
          Xác nhận gỡ xe
        </b-button>
      </div>
    </b-modal>

    <!-- Modal: Override Price (BE-029) -->
    <b-modal
      v-model="overridePriceDialog.show"
      title="Sửa giá item"
      hide-footer
      no-close-on-backdrop
    >
      <b-form-group>
        <label>Chọn item:</label>
        <b-form-select
          v-model="overridePriceDialog.itemId"
          :options="overridePriceItemOptions"
          size="sm"
        />
      </b-form-group>
      <b-form-group>
        <label>Giá mới (đ) <b class="text-danger">*</b>:</label>
        <b-form-input
          v-model.number="overridePriceDialog.newPrice"
          size="sm"
          type="number"
          placeholder="Giá mới"
        />
      </b-form-group>
      <b-form-group>
        <label>Lý do <b class="text-danger">*</b> (tối thiểu 10 ký tự):</label>
        <b-form-textarea
          v-model="overridePriceDialog.reason"
          size="sm"
          :rows="3"
          placeholder="Nhập lý do sửa giá"
          :state="overridePriceDialog.error ? false : null"
        />
        <b-form-invalid-feedback :state="!overridePriceDialog.error">
          {{ overridePriceDialog.error }}
        </b-form-invalid-feedback>
      </b-form-group>
      <div class="d-flex justify-content-end mt-3">
        <b-button
          class="mr-2"
          size="sm"
          variant="secondary"
          :disabled="overridePriceDialog.submitting"
          @click="overridePriceDialog.show = false"
        >
          Đóng
        </b-button>
        <b-button
          size="sm"
          variant="primary"
          :disabled="overridePriceDialog.submitting"
          @click="onSubmitOverridePrice"
        >
          Lưu giá mới
        </b-button>
      </div>
    </b-modal>
  </div>
</template>
<script>
import { REFERENCE_TYPE } from '@/utils/enum';
import KTCodePreview from '@/view/content/CodeTab.vue';
import KTWizard from '@/assets/js/components/wizard';
import ApiService from '@/core/services/api.service';
import moment from 'moment';
// common import
import { validationMixin } from 'vuelidate';
import {
  apiCommonMixin,
  linkMixin,
  commonMixin,
  calculateMixin,
} from '@/view/mixins/';

// import component
import CustomerInfoSection from '@/view/components/contracts/CustomerInfoSection';
import ContractInfo from '@/view/components/contracts/info';
import EmployeeInfo from '@/view/components/contracts/EmployeeInfo';
import Discount from '@/view/components/contracts/Discount';
import PaymentTerm from '@/view/components/contracts/PaymentTerm';
import DownPaymentForm from '@/view/components/payments/DownPaymentForm';
// import BillPayment from '@/view/components/bills/BillPayment';
// import OrderInfo from '@/view/components/order/OrderInfo';
// import OrderNote from '@/view/components/order/OrderNote';
// import OrderDiscount from '@/view/components/order/OrderDiscount';
// import OrderHeader from '@/view/components/order/OrderHeader';
import ProductTable from '@/view/components/contracts/ProductTable';
// import OrderTransactions from '@/view/components/OrderTransactions.vue';
import UploadFile from '@/view/modules/upload/Upload';
import QRCodeModal from '@/view/components/bills/QRCodeModal.vue';
import Autosuggest from '@/view/base/auto-sugguest/AutoSuggest.vue';

import SaveDataUtil from '@/utils/saveDataToLocal';
import { mapGetters } from 'vuex';
import { EventBus } from '@/core/services/event-bus';
import debounce from 'debounce';
import ContractTransaction from '@/view/components/ContractTransactions.vue';

// setter vuex
import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module';
import {
  HANDLE_SET_ORDER_INFO,
  HANDLE_PURGE_ORDER_INFO,
} from '@/core/services/store/modules/order/order-info.module';
import {
  SET_CUSTOMER_ORDER_INFO,
  PURGE_CUSTOMER_ORDER_INFO,
} from '@/core/services/store/modules/order/order-customer-info.module';
import {
  SET_ORDER_DISCOUNT_INFO,
  PURGE_ORDER_DISCOUNT_INFO,
} from '@/core/services/store/modules/order/order-discount.module';
import {
  SET_ORDER_NOTE_INFO,
  PURGE_ORDER_NOTE_INFO,
} from '@/core/services/store/modules/order/order-note.module';
import {
  SET_PRODUCTS,
  PURGE_PRODUCTS,
} from '@/core/services/store/modules/order/order-product-table.module';
import {
  PURGE_INTEREST_ZERO,
  PURGE_INSTALLMENT_PROGRAM,
  PURGE_INSTALLMENT_SHINHAN,
  PURGE_INTEREST_SHINHAN,
  SET_INTEREST,
  SET_INSTALLMENT_PROGRAM,
  SET_INSTALLMENT_SHINHAN,
  SET_INTEREST_SHINHAN,
} from '@/core/services/store/modules/payment/payment-installment.module';
import {
  makeToastFaile,
  getValueByKey,
  cloneDeep,
  unMaskPrice,
  makeToastFailHtml,
  convertPrice,
} from '@/utils/common';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

import { ITEM_TYPE, ORDER_STATUS, PAYMENT_TYPE } from '@/utils/enum.js';
import { TIME_TRIGGER } from '@/utils/constants';
import Swal from 'sweetalert2';
import { deleteDoc, doc, onSnapshot } from 'firebase/firestore';
import db from '../../../firebase/init';
import { makeToastSuccess } from '../../../utils/common';
import ContractService from '@/core/services/contract.service';
import {
  CONTRACT_UNALLOCATE_REASON,
  CONTRACT_UNALLOCATE_REASON_OPTIONS,
} from '@/core/constants/contractUnallocate';
import {
  CONTRACT_STATUS_LABEL,
  CONTRACT_STATE_TRANSITION_MAP,
} from '@/core/constants/contract';
import { CUSTOMER_TYPE_OPTIONS } from '@/core/constants/contractRequest';

// Luồng: pendingDeposit → deposited → allocated → invoiced → delivered → completed.
// "Giao xe" (invoiced → delivered) bị BE chặn nếu bill VAT chưa "Đã xuất" → lỗi hiện ở transitionDialog.error.
const CONTRACT_STEPPER_STATES = [
  'pendingDeposit',
  'deposited',
  'allocated',
  'invoiced',
  'delivered',
];
// Nhãn nút hành động cho từng bước transition (chỉ các bước user bấm tay).
const TRANSITION_ACTION_LABEL = {
  deposited: 'Xác nhận đặt cọc',
  allocated: 'Duyệt giữ hàng / Phân bổ xe',
  delivered: 'Giao xe',
  cancelled: 'Hủy HĐ',
};
// Nhãn loại audit.
const HISTORY_ACTION_LABEL = {
  STATE_TRANSITION: 'Chuyển trạng thái',
  PRICE_OVERRIDE: 'Sửa giá item',
  CANCEL: 'Hủy hợp đồng',
  EDIT_FIELD: 'Sửa thông tin',
  PAYMENT_VOID: 'Hủy phiếu thu',
  PAYMENT_UNRECONCILE: 'Gỡ mã đối soát',
};

export default {
  props: ['fromModal', 'orderIdFromModal'],
  mixins: [
    validationMixin,
    apiCommonMixin,
    linkMixin,
    calculateMixin,
    commonMixin,
  ],
  data() {
    return {
      // Sprint 3 enhancement state
      cancelDialog: {
        show: false,
        reason: '',
        error: '',
        submitting: false,
      },
      // Gỡ xe / Hủy ghép (allocated → deposited, KHÔNG hủy HĐ)
      unallocateDialog: {
        show: false,
        reasonCategory: null,
        note: '',
        error: '',
        submitting: false,
      },
      unallocateReasonOptions: CONTRACT_UNALLOCATE_REASON_OPTIONS,
      overridePriceDialog: {
        show: false,
        itemId: null,
        newPrice: null,
        reason: '',
        error: '',
        submitting: false,
      },
      // Luồng duyệt HĐMB — dialog chuyển trạng thái + lịch sử thao tác
      transitionDialog: {
        show: false,
        toStatus: null,
        error: '',
        submitting: false,
      },
      contractHistory: [],
      stepperStates: CONTRACT_STEPPER_STATES,
      exportingDocx: false,
      contractInfo: {
        id: null,
        type: null,
        contractDate: null,
        expectedDeliveryDate: null,
        contractNumber: null,
        storeId: null,
        customerId: null,
        // XOR với customerId — set khi customerType=BUSSINESS (HĐ KH doanh nghiệp).
        // BE Contract entity có 2 cột riêng customerId/customerBusinessId; convert từ
        // Đề nghị DN trả về customerId=null + customerBusinessId=<id>.
        customerBusinessId: null,
        customerType: 'CUSTOMER',
        customerName: null,
        customerPhone: null,
        customerAddress: null,
        customerGender: null,
        // Field bổ sung cho CustomerInfoSection ở mode editable (HĐMB tạo mới) —
        // unified `customer*` shape mà component mutate trực tiếp. Phần lớn KHÔNG
        // gửi BE (BE create() chỉ cần fullName/phoneNumber/address/gender cho CN,
        // name/phoneNo cho DN); khai báo sẵn để Vue 2 reactivity hoạt động.
        customerEmail: null,
        customerDob: null,
        customerCccdNo: null,
        customerCccdDate: null,
        customerCccdPlace: null,
        customerMst: null,
        customerFoundDate: null,
        customerRepresentative: null,
        customerRepPosition: null,
        authorizationNo: null,
        authorizationDate: null,
        saleId: null,
        saleName: null,
        shipperId: null,
        shipperName: null,
        // Phase B — 4 vai trò NV mở rộng (bán xe). Khai báo init để Vue 2
        // reactivity track + tránh undefined ở GET handler / save payload.
        technicalId: null,
        technicalName: null,
        cashierId: null,
        cashierName: null,
        managerId: null,
        managerName: null,
        assistantId: null,
        assistantName: null,
        approveBy: null,
        approveDate: null,
        paymentType: 'DIRECTLY',
        shippingAddress: null,
        totalAmountBeforeDiscount: null,
        discountType: 'AMOUNT',
        totalDiscountAmount: null,
        totalAmountAfterDiscount: null,
        createdBy: null,
        updatedBy: null,
        deleted: 0,
        createdAt: null,
        updatedAt: null,
        contractDetail: [],
        contractPaymentTerm: [],
        userApproved: null,
        userCreated: {
          id: null,
          fullName: null,
          code: null,
        },
        userUpdated: null,
        store: {
          id: null,
          name: null,
        },
      },
      contractEmployeeInfo: {
        saleId: null,
        saleName: '',
        technicalId: null,
        technicalName: '',
        cashierId: null,
        cashierName: '',
        accessoryStaffId: null,
        accessoryStaffName: '',
        managerId: null,
        managerName: '',
        assistantId: null,
        assistantName: '',
        customerReceptionId: null,
        customerReceptionName: '',
        shipperId: null,
        shipperName: '',
      },
      qrCodePaymentInfo: {},
      isAllowQRCode: false,
      transferAmount: 0,
      REFERENCE_TYPE,
      isLoading: false,
      fullPage: true,
      qrCode: {
        image: '',
        code: '',
      },
      isUsingQRCode: false,
      wizard: null,
      currentWizard: 1,
      orderId: null,
      preOrderId: null,
      orderInfo: {},
      orderNote: {},
      orderDiscount: {},
      orderCustomerInfo: {},
      orderPayment: {},
      onChangeProductTab: false,
      orderItems: [],
      loadingComponent: true,
      orderFinal: {
        storeId: null,
      },
      fromOrder: true,
      action: 'create',
      isApproved: false,
      isConfirm: false,
      isDisabled: false,
      footSetting: {
        continue: false,
      },
      orderCampainPhase: null,
      customerInfo: {
        customerId: null,
        customerName: null,
      },
      // ===== Customer info section (editable khi tạo HĐMB trực tiếp) =====
      // Cấu hình datepicker — pattern AddCustomer.vue / contract-request/Upsert.vue
      dpConfigs: {
        date: {
          format: 'DD/MM/YYYY',
          useCurrent: false,
          showClear: true,
          showClose: true,
          minDate: false,
          maxDate: false,
          locale: 'vi',
          sideBySide: true,
        },
      },
      customerTypeOptions: CUSTOMER_TYPE_OPTIONS.map((o) => ({
        value: o.value,
        text: o.text,
      })),
      appellationOptions: [
        { value: null, text: 'Chọn danh xưng' },
        { value: 1, text: 'Anh' },
        { value: 2, text: 'Chị' },
        { value: 3, text: 'Khác' },
      ],
      // Autosuggest state — tìm KH theo SĐT (chỉ dùng ở mode create)
      filteredCustomerOptions: [],
      businessTaxNoInput: '',
      filteredBusinessOptions: [],
      customerSnapshot: null,
      businessSnapshot: null,
      legalLoadedCustomerId: null,
      legalLoadedBusinessId: null,
    };
  },
  validations: {},
  components: {
    KTCodePreview,
    CustomerInfoSection,
    ContractInfo,
    EmployeeInfo,
    Discount,
    PaymentTerm,
    DownPaymentForm,
    ContractTransaction,
    // BillPayment,
    // OrderInfo,
    // OrderNote,
    // OrderDiscount,
    // OrderHeader,
    ProductTable,
    // OrderTransactions,
    UploadFile,
    QRCodeModal,
    Loading,
    Autosuggest,
  },
  async created() {
    this.mappingEnum();
    this.resetParamsVuex();
    await this.fetchContract();
    // Load lịch sử ngay để hiển thị inline lý do gỡ xe gần nhất (xem computed
    // unallocateReason) — tương tự cancelReason, không bắt user mở tab Lịch sử.
    if (this.contractInfo.id) {
      this.loadContractHistory();
    }
  },
  async mounted() {
    const title = !this.contractInfo.id
      ? 'Thêm mới hợp đồng'
      : 'Cập nhật hợp đồng';
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: 'Hợp đồng', route: '/contracts' },
      { title: 'Danh sách hợp đồng mua bán', route: '/contracts' },
      { title: title },
    ]);

    this.wizard = new KTWizard('kt_wizard_v4_2', {
      startStep: this.currentWizard,
      clickableSteps: true,
    });

    this.$nextTick(function () {
      this.wizard.on('change', this.onChangeTab);
    });
    await this.getPaymentResult();
  },
  destroyed() {
    this.resetParamsVuex();
  },
  computed: {
    /**
     * Khóa section thông tin khách:
     *  - Tạo mới (action=create): luôn cho nhập (HĐMB trực tiếp).
     *  - Edit + HĐ tạo từ Đề Nghị (có contractRequestId): KHÓA (snapshot bất
     *    biến — BE cũng chặn, RULE-003).
     *  - Edit + HĐ tạo trực tiếp (không contractRequestId): CHO sửa snapshot.
     */
    isCustomerLocked() {
      return this.action === 'update' && !!this.contractInfo.contractRequestId;
    },
    /**
     * Có thể Hủy HĐ khi status NOT IN (invoiced, delivered, completed, cancelled)
     * VÀ HĐ chưa có hóa đơn — match BE guard (BE-026 + CONTRACT_CREATED_BILL).
     * HĐ "Đã tạo hóa đơn" / có Bill thì không cho hủy (phải xóa hóa đơn trước).
     */
    canCancelContract() {
      const s = this.contractInfo && this.contractInfo.status;
      if (!s) return false;
      if (this.contractInfo && this.contractInfo.bill) return false;
      return !['invoiced', 'delivered', 'completed', 'cancelled'].includes(s);
    },
    /**
     * Cho export Word khi HĐ đã save (có id) và user có permission CONTRACT_VIEW.
     */
    canExportDocx() {
      if (!this.contractInfo || !this.contractInfo.id) return false;
      return SaveDataUtil.checkPermissions(['CONTRACT_VIEW']);
    },
    /**
     * Override price chỉ cho phép khi HĐ chưa giữ hàng (chưa `allocated` trở đi).
     */
    canOverridePrice() {
      const s = this.contractInfo && this.contractInfo.status;
      if (!s) return false;
      return ![
        'allocated',
        'paid',
        'invoiced',
        'delivered',
        'completed',
        'cancelled',
      ].includes(s);
    },
    /**
     * Bước kế tiếp hợp lệ từ state hiện tại (loại 'cancelled' — đã có nút "Hủy HĐ" riêng).
     */
    nextTransitions() {
      const s = this.contractInfo && this.contractInfo.status;
      if (!s) return [];
      return (CONTRACT_STATE_TRANSITION_MAP[s] || []).filter(
        (x) => x !== 'cancelled',
      );
    },
    /**
     * Index bước hiện tại trong stepper (−1 nếu HĐ đã hủy hoặc chưa có status).
     */
    currentStepIndex() {
      const s = this.contractInfo && this.contractInfo.status;
      if (!s) return -1;
      return this.stepperStates.indexOf(s);
    },
    /**
     * Map { status: { name, code, at } } — người thực hiện bước transition tới state đó.
     * Lấy từ ContractHistory (action STATE_TRANSITION); bước "Chờ ký" fallback về người tạo HĐ.
     */
    stepActorMap() {
      const map = {};
      const history = this.contractHistory || [];
      const transitions = history
        .filter((h) => h.action === 'STATE_TRANSITION' && h.toStatus)
        .sort((a, b) => new Date(a.changedAt) - new Date(b.changedAt));
      transitions.forEach((h) => {
        const u = h.user || {};
        map[h.toStatus] = {
          name: u.fullName || u.userName || h.changedBy || '',
          code: u.code || '',
          at: h.changedAt,
        };
      });
      // Bước đầu "Chờ cọc" — nếu chưa có history → dùng người tạo HĐ.
      if (
        !map.pendingDeposit &&
        this.contractInfo &&
        this.contractInfo.userCreated
      ) {
        const u = this.contractInfo.userCreated;
        map.pendingDeposit = {
          name: u.fullName || u.userName || '',
          code: u.code || '',
          at: this.contractInfo.createdAt,
        };
      }
      return map;
    },
    /** Người hủy HĐ (cho chip "Đã hủy"). */
    cancelledActor() {
      return this.stepActorMap.cancelled || null;
    },
    // Ghi chú khi Gỡ xe chỉ bắt buộc/hiện khi lý do = "Khác" (đồng bộ BE
    // UnallocateContractDto @ValidateIf reasonCategory === OTHER).
    isUnallocateOther() {
      return (
        this.unallocateDialog.reasonCategory ===
        CONTRACT_UNALLOCATE_REASON.OTHER
      );
    },
    // Lý do gỡ xe gần nhất (allocated → deposited) — BE lưu trong ContractHistory
    // (field/reason) chứ KHÔNG trên contract entity. Hiện inline khi HĐ đang ở
    // 'deposited' (sau khi gỡ) để user thấy ngay, giống cancelReason. contractHistory
    // BE trả order changedAt DESC nên .find lấy bản ghi gỡ mới nhất.
    unallocateReason() {
      if (!this.contractInfo || this.contractInfo.status !== 'deposited') {
        return null;
      }
      const rec = (this.contractHistory || []).find(
        (h) =>
          h &&
          h.action === 'STATE_TRANSITION' &&
          h.fromStatus === 'allocated' &&
          h.toStatus === 'deposited',
      );
      return rec ? rec.reason || rec.field || null : null;
    },
    // HĐ có ≥1 phiếu báo có (TRANSFER) chưa nhập mã tham chiếu (code rỗng).
    // Mã tham chiếu không còn bắt buộc khi tạo phiếu → cảnh báo để bổ sung sau.
    hasMissingPaymentCode() {
      const payments = (this.contractInfo && this.contractInfo.payments) || [];
      return payments.some(
        (p) =>
          p &&
          !p.deleted &&
          p.type === 'TRANSFER' &&
          (!p.code || String(p.code).trim() === ''),
      );
    },
    /**
     * Options cho select item trong modal Override Price.
     */
    overridePriceItemOptions() {
      const details =
        (this.contractInfo && this.contractInfo.contractDetail) || [];
      return [
        { value: null, text: '-- Chọn item --' },
        ...details.map((d) => ({
          value: d.id,
          text: `${d.productName} (${this.$options.filters?.currency?.(d.productPrice) || d.productPrice}đ)`,
        })),
      ];
    },
    ...mapGetters([
      'getProducts',
      'getOrderInfo',
      'getOrderCustomerInfo',
      'getOrderDiscount',
      'getOrderNote',
      'getInstallmentInterestZero',
      'getInstallmentProgram',
      'getInstallmentShinhan',
    ]),
    totalPriceItem() {
      let totalPrice = 0;
      this.orderItems.map((item) => {
        if (item.orderItemType !== ITEM_TYPE.GIFT) {
          const totalPriceItem = this.calculateTotalAmountOrderItems(item);
          totalPrice += totalPriceItem;
        }
      });
      return totalPrice;
    },
    totalAmount() {
      let totalPrice = 0;
      this.orderItems.map((item) => {
        if (item.orderItemType !== ITEM_TYPE.GIFT) {
          const totalPriceItem = this.calculateTotalAmountOrderItems(item);
          totalPrice += totalPriceItem;
        }
      });
      const discountAmount = unMaskPrice(this.orderDiscount.discountAmount);
      const discountType = this.orderDiscount.discountType;
      const customerShipFee = unMaskPrice(this.orderDiscount.customerShipFee);
      const shipFee = unMaskPrice(this.orderDiscount.shipFee);
      const subtractPointAmount = this.orderDiscount.subtractPointAmount;

      const discount = this.calculateDiscountAmount(
        discountAmount,
        discountType,
        totalPrice,
        1,
      );
      totalPrice =
        totalPrice -
        Number(discount) +
        Number(customerShipFee) +
        Number(shipFee) -
        Number(subtractPointAmount);

      return totalPrice;
    },
    totalPrice() {
      let total = 0;
      return total;
    },
  },
  watch: {
    'contractInfo.customerId'(newId, oldId) {
      if (!newId || newId === oldId) return;
      if (newId === this.legalLoadedCustomerId) return;
      this.loadCustomerDetail(newId);
    },
    'contractInfo.customerBusinessId'(newId, oldId) {
      if (!newId || newId === oldId) return;
      if (newId === this.legalLoadedBusinessId) return;
      this.loadBusinessDetail(newId);
    },
    getOrderInfo: {
      handler(value) {
        this.orderInfo = value;
        //billpayment
        this.orderFinal.storeId = value.storeId;
      },
      deep: true,
    },
    getOrderCustomerInfo: {
      handler(value) {
        if (value) {
          this.orderCustomerInfo = value;
          if (
            this.orderId &&
            value.customerId !== this.customerInfo.customerId
          ) {
            this.orderCustomerInfo['customerId'] = this.customerInfo.customerId;
          }
          // this.orderCustomerInfo = value;
          //billpayment
          this.orderFinal.customerMobile = value.customerMobile;
          this.orderFinal.customerName =
            value.customerName ?? this.customerInfo.customerName;
        }
      },
      deep: true,
    },
    getOrderDiscount: {
      handler(value) {
        if (value) {
          this.orderDiscount = value;
        }
      },
      deep: true,
    },
    getOrderNote: {
      handler(value) {
        if (value) {
          this.orderNote = value;
        }
      },
      deep: true,
    },
    getProducts: {
      handler(value) {
        if (value) {
          this.orderItems = value;
        }
      },
      deep: true,
    },
  },
  methods: {
    /**
     * Xuất hợp đồng ra file .docx theo mẫu VinFast VF_PC01.81.
     * BE endpoint: GET /contract/:id/export-docx (responseType=blob).
     */
    async handleExportDocx() {
      if (!this.contractInfo || !this.contractInfo.id || this.exportingDocx) {
        return;
      }
      this.exportingDocx = true;
      try {
        const response = await ContractService.exportDocx(this.contractInfo.id);
        const cd =
          (response.headers && response.headers['content-disposition']) || '';
        const match = cd.match(/filename="(.+?)"/);
        const filename =
          (match && match[1]) ||
          `HD_${this.contractInfo.contractNumber || this.contractInfo.id}.docx`;
        const blob = new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
        makeToastSuccess('Đã tải file hợp đồng');
      } catch (error) {
        const status = error && error.response && error.response.status;
        let message = 'Xuất file thất bại';
        if (error && error.response && error.response.data instanceof Blob) {
          try {
            const text = await error.response.data.text();
            const parsed = JSON.parse(text);
            if (parsed && parsed.message) message = parsed.message;
          } catch (_) {
            // ignore
          }
        }
        if (status === 403) {
          message = 'Bạn không có quyền xuất hợp đồng';
        } else if (status === 500) {
          message = 'Lỗi server khi xuất file — vui lòng báo IT';
        }
        makeToastFaile(message);
      } finally {
        this.exportingDocx = false;
      }
    },
    // ===== Sprint 3 enhancement methods =====
    contractStatusLabel(status) {
      return CONTRACT_STATUS_LABEL[status] || status;
    },
    contractStatusVariant(status) {
      // Map sang BootstrapVue variant (khác Vuetify color trong constants/contract.js)
      const map = {
        pendingDeposit: 'warning',
        pendingSignature: 'warning',
        signed: 'info',
        deposited: 'info',
        allocated: 'info',
        paid: 'success',
        invoiced: 'primary',
        delivered: 'primary',
        completed: 'success',
        cancelled: 'danger', // badge "Đã hủy" đỏ, khớp màu icon X trong stepper
      };
      return map[status] || 'secondary';
    },
    goToContractRequest(id) {
      if (!id) return;
      this.$router.push({
        name: 'edit-contract-request',
        params: { id },
      });
    },
    // ===== Phiếu thu / phiếu báo có theo đợt thanh toán =====
    onAddReceiptForTerm({ term, paymentType, suggestedAmount }) {
      if (!this.contractInfo.id) {
        makeToastFaile('Vui lòng lưu hợp đồng trước khi thêm phiếu thu');
        return;
      }
      if (!term || !term.id) {
        makeToastFaile(
          'Đợt thanh toán chưa được lưu — vui lòng lưu hợp đồng trước',
        );
        return;
      }
      this.$refs.downPaymentForm.showModal({
        entityId: this.contractInfo.id,
        contractId: this.contractInfo.id,
        contractNumber: this.contractInfo.contractNumber,
        selectedStoreId: this.contractInfo.storeId,
        paymentTermId: term.id,
        paymentTerms: this.contractInfo.contractPaymentTerm,
        payments: this.contractInfo.payments,
        paymentType,
        amount: suggestedAmount,
      });
    },
    // ===== Luồng duyệt HĐMB — transition state + lịch sử =====
    transitionActionLabel(status) {
      return TRANSITION_ACTION_LABEL[status] || status;
    },
    stepClass(stepStatus) {
      if (this.currentStepIndex < 0) return 'is-todo';
      const idx = this.stepperStates.indexOf(stepStatus);
      if (idx < this.currentStepIndex) return 'is-done';
      if (idx === this.currentStepIndex) return 'is-current';
      return 'is-todo';
    },
    openTransitionDialog(toStatus) {
      this.transitionDialog = {
        show: true,
        toStatus,
        error: '',
        submitting: false,
      };
    },
    // Tạo hóa đơn từ HĐ đã phân bổ xe — mở màn hóa đơn (giống nút ở danh sách HĐ).
    createBill() {
      if (!this.contractInfo || !this.contractInfo.id) return;
      const route = this.$router.resolve({
        name: 'update-bill',
        query: { fromContractId: this.contractInfo.id },
      });
      window.open(route.href, '_blank');
    },
    async onSubmitTransition() {
      const d = this.transitionDialog;
      if (!d.toStatus) return;
      d.error = '';
      d.submitting = true;
      try {
        await ContractService.transition(this.contractInfo.id, {
          toStatus: d.toStatus,
        });
        makeToastSuccess('Đã cập nhật trạng thái hợp đồng');
        d.show = false;
        this.fetchContract();
        this.loadContractHistory();
      } catch (err) {
        d.error =
          (err &&
            err.response &&
            err.response.data &&
            err.response.data.message) ||
          err.message ||
          'Cập nhật trạng thái thất bại';
      } finally {
        d.submitting = false;
      }
    },
    historyActionLabel(action) {
      return HISTORY_ACTION_LABEL[action] || action;
    },
    formatHistoryTime(t) {
      return t ? moment(t).format('DD-MM-YYYY HH:mm') : '';
    },
    historyUserName(h) {
      const u = h && h.user;
      if (u)
        return u.fullName || u.userName || u.name || u.email || h.changedBy;
      return h && h.changedBy;
    },
    historyDetail(h) {
      if (!h) return '';
      if (h.action === 'STATE_TRANSITION') {
        const from = h.fromStatus
          ? this.contractStatusLabel(h.fromStatus)
          : '—';
        const to = h.toStatus ? this.contractStatusLabel(h.toStatus) : '—';
        return `${from} → ${to}${h.reason ? ` (${h.reason})` : ''}`;
      }
      if (h.action === 'PRICE_OVERRIDE') {
        return `${h.field || 'giá'}: ${h.oldValue || ''} → ${h.newValue || ''}${
          h.reason ? ` (${h.reason})` : ''
        }`;
      }
      if (h.action === 'CANCEL') {
        return h.reason || '';
      }
      if (h.action === 'PAYMENT_VOID') {
        return h.reason || h.oldValue || 'Hủy phiếu thu';
      }
      if (h.action === 'PAYMENT_UNRECONCILE') {
        return h.reason || h.oldValue || 'Gỡ mã đối soát';
      }
      if (h.action === 'EDIT_FIELD') {
        const LABELS = {
          contractDate: 'Ngày HĐ',
          expectedDeliveryDate: 'Ngày dự kiến giao xe',
          customerName: 'Tên KH',
          customerPhone: 'SĐT KH',
          customerAddress: 'Địa chỉ KH',
          customerGender: 'Giới tính KH',
          shippingAddress: 'Địa chỉ giao hàng',
          saleName: 'NV bán hàng',
          shipperName: 'NV giao hàng',
          paymentType: 'Hình thức thanh toán',
          discountType: 'Loại chiết khấu',
          totalDiscountAmount: 'Chiết khấu HĐ',
        };
        const SKIP = [
          'saleId',
          'shipperId',
          'customerId',
          'customerType',
          'totalAmountBeforeDiscount',
          'totalAmountAfterDiscount',
          'shippername',
        ];
        const fmt = (k, v) => {
          if (v == null || v === '') return '∅';
          if (k === 'contractDate' || k === 'expectedDeliveryDate')
            return String(v).slice(0, 10);
          if (k === 'totalDiscountAmount')
            return Number(v).toLocaleString('vi-VN');
          return String(v);
        };
        let newV = null;
        try {
          newV = h.newValue ? JSON.parse(h.newValue) : null;
        } catch (e) {
          // newValue là chuỗi thường (vd lịch sử thay đổi sản phẩm: "+ Thêm SP ...")
          return h.newValue || h.field || 'Cập nhật thông tin';
        }
        if (newV && typeof newV === 'object' && !Array.isArray(newV)) {
          let oldV = null;
          try {
            oldV = h.oldValue ? JSON.parse(h.oldValue) : null;
          } catch (e) {
            oldV = null;
          }
          const parts = [];
          Object.keys(newV).forEach((k) => {
            if (SKIP.includes(k) || !LABELS[k]) return;
            const oStr = fmt(k, oldV ? oldV[k] : undefined);
            const nStr = fmt(k, newV[k]);
            if (oStr === nStr) return;
            parts.push(`${LABELS[k]}: ${oStr} → ${nStr}`);
          });
          return parts.length
            ? parts.join('; ')
            : h.field || 'Cập nhật thông tin';
        }
        // newValue rỗng / không phải object
        return (
          (typeof h.newValue === 'string' && h.newValue) ||
          h.field ||
          'Cập nhật thông tin'
        );
      }
      return [h.field, h.oldValue, h.newValue].filter(Boolean).join(' / ');
    },
    loadContractHistory() {
      const id = this.contractInfo && this.contractInfo.id;
      if (!id) return;
      ContractService.getHistory(id)
        .then((res) => {
          const body = res && res.data;
          this.contractHistory = Array.isArray(body)
            ? body
            : (body && body.data) || [];
        })
        .catch(() => {
          this.contractHistory = [];
        });
    },
    openOverridePriceDialog() {
      this.overridePriceDialog = {
        show: true,
        itemId: null,
        newPrice: null,
        reason: '',
        error: '',
        submitting: false,
      };
    },
    async onSubmitCancelContract() {
      const reason = (this.cancelDialog.reason || '').trim();
      if (reason.length < 10) {
        this.cancelDialog.error = 'Lý do tối thiểu 10 ký tự';
        return;
      }
      this.cancelDialog.error = '';
      this.cancelDialog.submitting = true;
      try {
        await ContractService.cancel(this.contractInfo.id, reason);
        makeToastSuccess('Đã hủy HĐ');
        this.cancelDialog.show = false;
        this.fetchContract();
        this.loadContractHistory();
      } catch (err) {
        const msg =
          (err &&
            err.response &&
            err.response.data &&
            err.response.data.message) ||
          err.message ||
          'Hủy HĐ thất bại';
        this.cancelDialog.error = msg;
      } finally {
        this.cancelDialog.submitting = false;
      }
    },
    openUnallocateDialog() {
      this.unallocateDialog = {
        show: true,
        reasonCategory: null,
        note: '',
        error: '',
        submitting: false,
      };
    },
    async onSubmitUnallocate() {
      const d = this.unallocateDialog;
      if (!d.reasonCategory) {
        d.error = 'Vui lòng chọn lý do';
        return;
      }
      const note = (d.note || '').trim();
      // Ghi chú chỉ bắt buộc khi lý do = "Khác".
      if (this.isUnallocateOther && note.length < 10) {
        d.error = 'Ghi chú tối thiểu 10 ký tự khi chọn lý do Khác';
        return;
      }
      d.error = '';
      d.submitting = true;
      try {
        await ContractService.unallocate(this.contractInfo.id, {
          reasonCategory: d.reasonCategory,
          note: this.isUnallocateOther ? note : '',
        });
        makeToastSuccess('Đã gỡ xe — HĐ về Đã đặt cọc');
        d.show = false;
        this.fetchContract();
        this.loadContractHistory();
      } catch (err) {
        const msg =
          (err &&
            err.response &&
            err.response.data &&
            err.response.data.message) ||
          err.message ||
          'Gỡ xe thất bại';
        d.error = msg;
      } finally {
        d.submitting = false;
      }
    },
    async onSubmitOverridePrice() {
      const d = this.overridePriceDialog;
      if (!d.itemId) {
        d.error = 'Vui lòng chọn item';
        return;
      }
      const price = Number(d.newPrice);
      if (!price || price <= 0) {
        d.error = 'Giá mới phải > 0';
        return;
      }
      const reason = (d.reason || '').trim();
      if (reason.length < 10) {
        d.error = 'Lý do tối thiểu 10 ký tự';
        return;
      }
      d.error = '';
      d.submitting = true;
      try {
        await ContractService.overrideItemPrice(
          this.contractInfo.id,
          d.itemId,
          {
            newPrice: price,
            reason,
          },
        );
        makeToastSuccess('Đã sửa giá item');
        d.show = false;
        this.fetchContract();
      } catch (err) {
        d.error =
          (err &&
            err.response &&
            err.response.data &&
            err.response.data.message) ||
          err.message ||
          'Sửa giá thất bại';
      } finally {
        d.submitting = false;
      }
    },
    onClickGenerateQR(payment) {
      this.qrCodePaymentInfo = payment;
      if (payment.viaQRCode) {
        this.transferAmount = payment.paymentAmount;
        setTimeout(() => {
          this.$refs['qr-code-modal'].generateQRCode();
        }, TIME_TRIGGER);
      }
    },
    async getPaymentResult() {
      const VERIFY_COLLECTION = 'payment-verify-results';
      onSnapshot(doc(db, VERIFY_COLLECTION, String(this.orderId)), (snap) => {
        if (snap.exists()) {
          const snapData = snap.data();
          if (String(snapData.referenceNumber) === String(this.orderId)) {
            //  remove doc
            deleteDoc(doc(db, VERIFY_COLLECTION, String(this.orderId)));
            this.$refs['qr-code-modal'].hideModal();
            Swal.fire(
              'Thành công',
              'Bạn đã thanh toán thành công!',
              'success',
            ).then(() => {
              this.$router.go(this.$router.currentRoute);
            });
          }
        }
      });
    },
    onGenerateQR() {
      this.isLoading = true;
    },
    afterGenerateQR() {
      this.isLoading = false;
    },
    fetchContract() {
      this.contractInfo.id = this.$route.params.id || null;
      this.isApproved = this.$route.query.isApproved || false;
      this.isConfirm = this.$route.query.isConfirm || false;

      this.isDisabled = this.isApproved || this.isConfirm ? true : false;

      if (this.contractInfo.id) {
        this.loadingComponent = false;
        this.action = 'update';
        this.isAllowQRCode = true;
        this.getContractDetail(this.contractInfo.id);
        // Reload luôn bút toán (Transaction) — phiếu thu/hủy phiếu thay đổi bút toán
        // nhưng contractId không đổi nên component bút toán không tự fetch lại.
        if (
          this.$refs.contractTransactionRef &&
          this.$refs.contractTransactionRef.fetchMainData
        ) {
          this.$refs.contractTransactionRef.fetchMainData();
        }
        // Reload lịch sử thay đổi HĐ (hủy phiếu thu ghi entry PAYMENT_VOID).
        this.loadContractHistory();
      }
    },
    // ===================================================================
    // Customer info inline (HĐMB trực tiếp) — autocomplete tìm KH theo SĐT.
    // Pattern theo contract-request/Upsert.vue (debounce + Autosuggest + ApiService).
    // Khi user gõ SĐT mới (không chọn KH có sẵn) → customerId = null → BE tự tạo KH.
    // ===================================================================
    debounceSearchCustomer: debounce(function () {
      this.fetchCustomerSuggestions();
    }, TIME_TRIGGER),
    onSearchCustomerChange(text) {
      // User gõ trong ô SĐT → reset customerId (KH chưa được chọn) + giữ text vào
      // contractInfo để v-model giữ giá trị; debounce gọi BE search.
      const value = text || '';
      this.contractInfo.customerPhone = value;
      this.contractInfo.customerId = null;
      this.legalLoadedCustomerId = null;
      this.filteredCustomerOptions = [];
      if (!value.trim()) return;
      this.debounceSearchCustomer();
    },
    fetchCustomerSuggestions() {
      const text = (this.contractInfo.customerPhone || '').trim();
      if (!text) return;
      ApiService.get(`customers/get-by-phone?phoneNumber=${text}`)
        .then((res) => {
          const list = (res && res.data && res.data.data) || [];
          if (list.length) {
            this.filteredCustomerOptions = list;
          } else {
            this.filteredCustomerOptions = [
              {
                message: 'SĐT không có trong hệ thống — sẽ tạo KH mới',
                phoneNumber: text,
              },
            ];
          }
        })
        .catch(() => {
          this.filteredCustomerOptions = [];
        });
    },
    onSelectCustomer(option) {
      const item = option && option.item ? option.item : null;
      if (!item) return;
      if (item.id) {
        // KH đã có trong hệ thống → fill các field từ snapshot.
        this.contractInfo.customerId = item.id;
        this.contractInfo.customerPhone = item.phoneNumber || '';
        this.contractInfo.customerName = item.fullName || '';
        this.contractInfo.customerAddress = item.address || '';
        this.contractInfo.customerGender = item.gender || null;
        this.contractInfo.customerEmail = item.email || null;
        // Datepicker dùng format 'DD/MM/YYYY' → BE trả ISO/YYYY-MM-DD nên phải convert,
        // không thì ô ngày sinh / ngày cấp CCCD hiển thị trống.
        this.contractInfo.customerDob = item.dateOfBirth
          ? moment(item.dateOfBirth).format('DD/MM/YYYY')
          : null;
        // CCCD / ngày cấp / nơi cấp — fill từ KH đã chọn.
        this.contractInfo.customerCccdNo = item.cccdNo || null;
        this.contractInfo.customerCccdDate = item.cccdDate
          ? moment(item.cccdDate).format('DD/MM/YYYY')
          : null;
        this.contractInfo.customerCccdPlace = item.cccdPlace || null;
      } else {
        // KH mới (suggestion "không có trong hệ thống") → giữ SĐT, clear phần còn lại.
        this.contractInfo.customerId = null;
        this.contractInfo.customerPhone = item.phoneNumber || '';
        this.contractInfo.customerName = null;
        this.contractInfo.customerAddress = null;
        this.contractInfo.customerGender = null;
        this.contractInfo.customerEmail = null;
        this.contractInfo.customerDob = null;
        this.contractInfo.customerCccdNo = null;
        this.contractInfo.customerCccdDate = null;
        this.contractInfo.customerCccdPlace = null;
      }
    },
    debounceSearchBusiness: debounce(function () {
      this.fetchBusinessSuggestions();
    }, TIME_TRIGGER),
    onSearchBusinessChange(text) {
      const value = text || '';
      this.businessTaxNoInput = value;
      // Input giờ là Mã số thuế → ghi thẳng vào customerMst để submit gửi taxNo
      // (trước đây chỉ giữ ở businessTaxNoInput, taxNo không bao giờ lưu).
      this.contractInfo.customerMst = value;
      this.contractInfo.customerBusinessId = null;
      this.legalLoadedBusinessId = null;
      this.filteredBusinessOptions = [];
      if (!value.trim()) return;
      this.debounceSearchBusiness();
    },
    fetchBusinessSuggestions() {
      const text = (this.businessTaxNoInput || '').trim();
      if (!text) return;
      ApiService.query(`businesses`, {
        params: { search: text, page: 1, limit: 10 },
      })
        .then((res) => {
          const payload = (res && res.data && res.data.data) || null;
          let list = [];
          if (Array.isArray(payload)) list = payload;
          else if (payload && Array.isArray(payload.data)) list = payload.data;
          if (list.length) {
            this.filteredBusinessOptions = list;
          } else {
            this.filteredBusinessOptions = [
              { message: 'DN không có trong hệ thống', taxNo: text },
            ];
          }
        })
        .catch(() => {
          this.filteredBusinessOptions = [];
        });
    },
    onSelectBusiness(option) {
      const item = option && option.item ? option.item : null;
      if (!item) return;
      if (item.id) {
        this.contractInfo.customerBusinessId = item.id;
        this.businessTaxNoInput = item.taxNo || '';
        this.contractInfo.customerName = item.name || '';
        this.contractInfo.customerPhone = item.phoneNo || '';
        this.contractInfo.customerAddress = item.address || '';
        this.contractInfo.customerEmail = item.email || null;
        this.contractInfo.customerMst = item.taxNo || '';
      } else {
        this.contractInfo.customerBusinessId = null;
        this.businessTaxNoInput = item.taxNo || '';
        this.contractInfo.customerMst = item.taxNo || '';
      }
    },
    async loadCustomerDetail(customerId) {
      if (!customerId) return;
      try {
        const res = await ApiService.get(`customers/${customerId}`);
        const c = (res && res.data && res.data.data) || (res && res.data) || {};
        this.customerSnapshot = c;
        if (c.cccdNo && !this.contractInfo.customerCccdNo) {
          this.contractInfo.customerCccdNo = c.cccdNo;
        }
        if (c.cccdDate && !this.contractInfo.customerCccdDate) {
          this.contractInfo.customerCccdDate = moment(c.cccdDate).format(
            'DD/MM/YYYY',
          );
        }
        if (c.cccdPlace && !this.contractInfo.customerCccdPlace) {
          this.contractInfo.customerCccdPlace = c.cccdPlace;
        }
        this.legalLoadedCustomerId = customerId;
      } catch (err) {
        console.error('loadCustomerDetail error', err);
      }
    },
    async loadBusinessDetail(businessId) {
      if (!businessId) return;
      try {
        const res = await ApiService.get(`businesses/${businessId}/detail`);
        const b = (res && res.data && res.data.data) || (res && res.data) || {};
        this.businessSnapshot = b;
        if (b.taxNo) this.businessTaxNoInput = b.taxNo;
        if (b.representative && !this.contractInfo.customerRepresentative) {
          this.contractInfo.customerRepresentative = b.representative;
        }
        if (b.repPosition && !this.contractInfo.customerRepPosition) {
          this.contractInfo.customerRepPosition = b.repPosition;
        }
        if (b.foundDate && !this.contractInfo.customerFoundDate) {
          this.contractInfo.customerFoundDate = moment(b.foundDate).format(
            'DD/MM/YYYY',
          );
        }
        if (b.taxNo && !this.contractInfo.customerMst) {
          this.contractInfo.customerMst = b.taxNo;
        }
        this.legalLoadedBusinessId = businessId;
      } catch (err) {
        console.error('loadBusinessDetail error', err);
      }
    },
    resetParamsVuex() {
      this.$store.dispatch(HANDLE_PURGE_ORDER_INFO);
      this.$store.dispatch(PURGE_ORDER_NOTE_INFO);
      this.$store.dispatch(PURGE_CUSTOMER_ORDER_INFO);
      this.$store.dispatch(PURGE_ORDER_DISCOUNT_INFO);
      this.$store.dispatch(PURGE_PRODUCTS);
      this.$store.dispatch(PURGE_INTEREST_ZERO);
      this.$store.dispatch(PURGE_INSTALLMENT_PROGRAM);
      this.$store.dispatch(PURGE_INTEREST_SHINHAN);
      this.$store.dispatch(PURGE_INSTALLMENT_SHINHAN);
    },
    mappingEnum() {
      const userInfor = this.getEmployeeFromLocal();
      this.userInfor = userInfor;
    },
    getEmployeeFromLocal() {
      const userFromLocal = SaveDataUtil.getData('employee_info');
      if (userFromLocal) {
        const tmpInfo = JSON.parse(userFromLocal);
        return tmpInfo;
      }
    },
    onChangeTab(item) {
      // Wizard steps: 1 = Thông tin, 2 = Lịch sử thao tác, 3 = Đính kèm.
      const TAB = {
        INFO: 1,
        HISTORY: 2,
      };
      this.onChangeProductTab = item.currentStep !== TAB.INFO;
      if (item.currentStep === TAB.HISTORY) {
        this.loadContractHistory();
      }
    },
    mappingOrderVuex(data) {
      const orderInfoVuex = this.getOrderInfo;
      const orderInfo = getValueByKey(orderInfoVuex, data);

      this.$store.dispatch(HANDLE_SET_ORDER_INFO, orderInfo);

      const orderNoteVuex = this.getOrderNote;
      const orderNote = getValueByKey(orderNoteVuex, data);
      this.$store.dispatch(SET_ORDER_NOTE_INFO, orderNote);

      const orderDiscountInfoVuex = this.getOrderDiscount;
      const orderDiscountInfo = getValueByKey(orderDiscountInfoVuex, data);
      this.$store.dispatch(SET_ORDER_DISCOUNT_INFO, orderDiscountInfo);

      const orderCustomerInfoVuex = this.getOrderCustomerInfo;
      const orderCustomerInfo = getValueByKey(orderCustomerInfoVuex, data);
      this.$store.dispatch(SET_CUSTOMER_ORDER_INFO, orderCustomerInfo);

      const orderItems = this.handleOrderItemGet(cloneDeep(data.orderItems));
      this.$store.dispatch(SET_PRODUCTS, orderItems);

      // Installment Interest
      this.$store.dispatch(SET_INTEREST, data.isInterestZero);

      const installmentProgram = this.getInstallmentProgram;
      const installmentProgramInfor = getValueByKey(
        installmentProgram,
        data.installmentProgram
          ? {
              details: [],
              installmentProgramId: data.installmentProgram.id,
              installmentProgramName: data.installmentProgram.name,
              installmentProgramMonthNo: data.installmentProgramMonthNo,
              installmentProgramPrepayPercent:
                data.installmentProgramPrepayPercent,
              prepayPercent: data.installmentProgram.prepayPercent,
              conversionFeePercent:
                data.installmentProgram.conversionFeePercent,
              monthNo: data.installmentProgram.monthNo,
            }
          : {},
      );
      this.$store.dispatch(SET_INSTALLMENT_PROGRAM, installmentProgramInfor);

      // Installment Shinhan
      this.$store.dispatch(
        SET_INTEREST_SHINHAN,
        data.loanApplicationId ? true : false,
      );
      const installmentShinhan = this.getInstallmentShinhan;
      const intallmentShinhanInfor = getValueByKey(installmentShinhan, data);
      this.$store.dispatch(SET_INSTALLMENT_SHINHAN, intallmentShinhanInfor);

      this.orderFinal = data;
      this.transferAmount = this.orderFinal.transferAmount;

      setTimeout(() => {
        this.loadingComponent = true;
      }, TIME_TRIGGER);
    },
    debounceUpsertOrder: debounce(function () {
      this.upsertContract();
    }, 300),

    debounceApproveContract: debounce(function () {
      this.approveContract();
    }, 300),

    debounceConfirmContract: debounce(function () {
      this.confirmContract();
    }, 300),

    calcPayments(payments, isInterestZero) {
      if (
        !isInterestZero &&
        payments.installments.length &&
        payments.installments[0].child
      ) {
        payments.installments[0].child.deleted = 1;
      }
      return payments;
    },
    calcConversionFee(installments) {
      return installments.reduce((result, currentItem) => {
        if (currentItem.child && !currentItem.child.deleted) {
          result += currentItem.child.paymentAmount || 0;
        }
        return result;
      }, 0);
    },
    upsertOrder: function () {
      const checkDate = this.orderInfo.checkDate
        ? moment(this.orderInfo.checkDate, 'DD/MM/YYYY').format('YYYY-MM-DD')
        : null;

      const paymentDate = this.orderDiscount.paymentDate
        ? moment(this.orderInfo.checkDate, 'DD/MM/YYYY').format('YYYY-MM-DD')
        : null;

      const orderItems = this.handleOrderItemUpsert(cloneDeep(this.orderItems));

      const discountAmount =
        unMaskPrice(this.orderDiscount.discountAmount) || 0;
      const customerShipFee =
        unMaskPrice(this.orderDiscount.customerShipFee) || 0;
      const shipFee = unMaskPrice(this.orderDiscount.shipFee) || 0;

      const isInterestZero = this.getInstallmentInterestZero ? 1 : 0;
      const intallmentProgram = this.getInstallmentProgram;
      const installmentShinhan = this.getInstallmentShinhan;

      const orderPayment = this.calcPayments(this.orderPayment, isInterestZero);
      const conversionFee = this.calcConversionFee(orderPayment.installments);
      const order = {
        id: this.orderId,
        ...this.orderInfo,
        checkDate: checkDate,
        ...this.orderCustomerInfo,
        ...this.orderDiscount,
        discountAmount: discountAmount,
        customerShipFee: customerShipFee,
        shipFee: shipFee,
        paymentDate: paymentDate,
        ...this.orderNote,
        ...orderPayment,
        isInterestZero: isInterestZero,
        orderItems: orderItems,
        intallmentProgram,
        installmentShinhan,
        conversionFee,
      };

      const [isValid, messages] = this.validateUpsertOrder(order);

      if (!isValid) {
        makeToastFailHtml(this, messages);
        return;
      }

      let method = null;
      if (this.preOrderId) {
        method = 'post';
      } else {
        method = this.action === 'update' ? 'put' : 'post';
      }

      ApiService[method]('/contract', order)
        .then((response) => {
          if (!this.orderId) {
            this.orderId = response.data.data;
          }
          if (this.fromModal) {
            this.$emit('refresh-order');
          } else {
            this.settingFooter();
          }
        })
        .catch((err) => {
          if (!err.response) {
            // network error
            makeToastFaile('Lỗi!');
          } else {
            const message = err.response.data.message;
            makeToastFaile(message);
          }
          this.$nprogress.done();
        });
    },
    upsertContract() {
      const [isValid, messages] = this.validateUpsertContract(
        this.contractInfo,
      );

      if (!isValid) {
        makeToastFailHtml(this, messages);
        return;
      }
      const method = this.action === 'update' ? 'put' : 'post';
      // SP tặng kèm (orderItemType = GIFT) gom theo item chính (belongOrderClientId).
      const giftsByParent = {};
      this.contractInfo.contractDetail
        .filter((d) => d.orderItemType === ITEM_TYPE.GIFT)
        .forEach((g) => {
          const key = g.belongOrderClientId;
          if (!key) return;
          (giftsByParent[key] = giftsByParent[key] || []).push({
            productId: g.productId,
            productName: g.productName,
            quantity: Number(g.quantity) || 1,
            productChassisId: g.productChassisId || null,
            productSerialId: g.productSerialId || null,
          });
        });
      // SP bán kèm (orderItemType = ATTACH) gom theo item chính — GIỮ giá/CK.
      const attachsByParent = {};
      this.contractInfo.contractDetail
        .filter((d) => d.orderItemType === ITEM_TYPE.ATTACH)
        .forEach((a) => {
          const key = a.belongOrderClientId;
          if (!key) return;
          (attachsByParent[key] = attachsByParent[key] || []).push({
            productId: a.productId,
            productName: a.productName,
            productPrice:
              Number(unMaskPrice(a.sellingPriceMask) || a.productPrice) || 0,
            quantity: Number(a.quantity) || 1,
            discountType: a.discountType || 'AMOUNT',
            discountAmount: Number(unMaskPrice(a.discountAmount)) || 0,
            productChassisId: a.productChassisId || null,
            productSerialId: a.productSerialId || null,
          });
        });
      const contractDetails = this.contractInfo.contractDetail
        .filter(
          (d) =>
            d.orderItemType !== ITEM_TYPE.GIFT &&
            d.orderItemType !== ITEM_TYPE.ATTACH,
        )
        .map((detail) => {
          const item = {
            contractId: detail.contractId,
            productId: detail.productId,
            quantity: detail.quantity,
            discountAmount: unMaskPrice(detail.discountAmount),
            discountType: detail.discountType,
            productChassisId: detail.productChassisId,
            productSerialId: detail.productSerialId,
            vouchers: detail.vouchers || [],
            gifts: giftsByParent[detail._clientId] || [],
            attachs: attachsByParent[detail._clientId] || [],
          };
          if (detail['id']) {
            item['id'] = detail['id'];
          }
          return item;
        });
      const contractPaymentTerms = this.contractInfo.contractPaymentTerm.map(
        (payment) => {
          const item = {
            contractId: payment.contractId,
            name: payment['name'],
            totalAmount: unMaskPrice(payment['totalAmount']),
            fromDate: moment(payment['fromDate'], 'DD/MM/YYYY').format(
              'yyyy-MM-DD',
            ),
            toDate: moment(payment['toDate'], 'DD/MM/YYYY').format(
              'yyyy-MM-DD',
            ),
          };
          if (payment['id']) {
            item['id'] = payment['id'];
          }
          return item;
        },
      );

      const data = {
        contractDate: moment(
          this.contractInfo['contractDate'],
          'DD/MM/YYYY',
        ).format('YYYY-MM-DD'),
        expectedDeliveryDate: this.contractInfo['expectedDeliveryDate']
          ? moment(
              this.contractInfo['expectedDeliveryDate'],
              'DD/MM/YYYY',
            ).format('YYYY-MM-DD')
          : null,

        contractNumber: this.contractInfo['contractNumber'],
        storeId: this.contractInfo['storeId'],
        // XOR — gửi đúng field theo customerType để BE update không wipe link KH DN.
        // BE create() / update() đã align cùng convention (xem contract.service.ts).
        ...(this.contractInfo['customerType'] === 'BUSSINESS'
          ? {
              customerId: null,
              customerBusinessId: this.contractInfo['customerBusinessId'],
            }
          : {
              customerId: this.contractInfo['customerId'],
              customerBusinessId: null,
            }),
        customerType: this.contractInfo['customerType'],
        customerName: this.contractInfo['customerName'],
        customerPhone: this.contractInfo['customerPhone'],
        customerAddress: this.contractInfo['customerAddress'],
        customerGender: this.contractInfo['customerGender'],
        // Bug fix: trước đây payload bỏ email/CCCD → BE không lưu được dù
        // contractInfo đã có. cccdDate đang lưu DD/MM/YYYY → đổi YYYY-MM-DD
        // cho khớp BE (giống contractDate).
        customerEmail: this.contractInfo['customerEmail'] || null,
        // Bug fix: Ngày sinh trước đây KHÔNG nằm trong payload → BE không lưu.
        customerDob: this.contractInfo['customerDob']
          ? moment(this.contractInfo['customerDob'], 'DD/MM/YYYY').format(
              'YYYY-MM-DD',
            )
          : null,
        customerCccdNo: this.contractInfo['customerCccdNo'] || null,
        customerCccdDate: this.contractInfo['customerCccdDate']
          ? moment(this.contractInfo['customerCccdDate'], 'DD/MM/YYYY').format(
              'YYYY-MM-DD',
            )
          : null,
        customerCccdPlace: this.contractInfo['customerCccdPlace'] || null,
        // Pháp lý DN — gửi khi BUSSINESS để BE tạo CustomerBusiness có taxNo
        // (trước đây không gửi → lỗi "Field 'taxNo' doesn't have a default value").
        ...(this.contractInfo['customerType'] === 'BUSSINESS'
          ? {
              customerMst: this.contractInfo['customerMst'] || null,
              customerRepresentative:
                this.contractInfo['customerRepresentative'] || null,
              customerRepPosition:
                this.contractInfo['customerRepPosition'] || null,
              customerFoundDate: this.contractInfo['customerFoundDate']
                ? moment(
                    this.contractInfo['customerFoundDate'],
                    'DD/MM/YYYY',
                  ).format('YYYY-MM-DD')
                : null,
              // Giấy ủy quyền số / Ngày ủy quyền (optional) — trước đây không
              // gửi → KH DN đã tồn tại chọn lại không lưu 2 field này.
              authorizationNo: this.contractInfo['authorizationNo'] || null,
              authorizationDate: this.contractInfo['authorizationDate']
                ? moment(
                    this.contractInfo['authorizationDate'],
                    'DD/MM/YYYY',
                  ).format('YYYY-MM-DD')
                : null,
            }
          : {}),
        saleId: this.contractInfo['saleId'],
        shipperId: this.contractInfo['shipperId'],
        // Phase B — 4 vai trò NV mở rộng (bán xe). Gửi cả Id + Name để BE save
        // luôn, không cần lookup. EmployeeInfo.onSelected đã ghi vào contractInfo.
        technicalId: this.contractInfo['technicalId'],
        technicalName: this.contractInfo['technicalName'],
        cashierId: this.contractInfo['cashierId'],
        cashierName: this.contractInfo['cashierName'],
        managerId: this.contractInfo['managerId'],
        managerName: this.contractInfo['managerName'],
        assistantId: this.contractInfo['assistantId'],
        assistantName: this.contractInfo['assistantName'],
        shippingAddress: this.contractInfo['shippingAddress'],
        paymentType: this.contractInfo['paymentType'],
        discountType: this.contractInfo['discountType'],
        totalDiscountAmount: unMaskPrice(
          this.contractInfo['totalDiscountAmount'],
        ),
        contractDetail: contractDetails,
        contractPaymentTerm: contractPaymentTerms,
      };
      if (this.action === 'update' && this.contractInfo['id']) {
        data['id'] = this.contractInfo['id'];
      }
      ApiService[method]('/contract', data)
        .then(({ data }) => {
          if (data.status && this.action === 'update') {
            makeToastSuccess('Cập nhật thông tin hợp đồng thành công');
            this.fetchContract();
            return;
          }
          if (data.status && this.action !== 'update') {
            makeToastSuccess('Tạo hợp đồng thành công');
            this.$router.push({ name: 'list' });
            return;
          }
        })
        .catch((err) => {
          if (!err.response) {
            // network error
            makeToastFaile('Lỗi!');
          } else {
            const message = err.response.data.message;
            makeToastFaile(message);
          }
          this.$nprogress.done();
        });
    },
    approveContract() {
      ApiService.post('/contract/approved', { id: this.contractInfo.id })
        .then(({ data }) => {
          if (data.status) {
            makeToastSuccess('Duyệt hợp đồng thành công');
            this.$router.push({ name: 'list' });
            return;
          }
        })
        .catch((err) => {
          if (!err.response) {
            // network error
            makeToastFaile('Lỗi!');
          } else {
            const message = err.response.data.message;
            makeToastFaile(message);
          }
          this.$nprogress.done();
        });
    },
    confirmContract() {
      const contractDetails = this.contractInfo.contractDetail
        .filter((d) => d.orderItemType !== ITEM_TYPE.GIFT)
        .map((detail) => {
          const item = {
            contractId: detail.contractId,
            productId: detail.productId,
            quantity: detail.quantity,
            discountAmount: unMaskPrice(detail.discountAmount),
            discountType: detail.discountType,
            productChassisId: detail.productChassisId,
            productSerialId: detail.productSerialId,
            vouchers: detail.vouchers || [],
          };
          if (detail['id']) {
            item['id'] = detail['id'];
          }
          return item;
        });
      const data = { id: this.contractInfo.id, contractDetails };
      ApiService.post('/contract/confirm', data)
        .then(({ data }) => {
          if (data.status) {
            makeToastSuccess('Duyệt hợp đồng thành công');
            this.$router.push({ name: 'list' });
            return;
          }
        })
        .catch((err) => {
          if (!err.response) {
            // network error
            makeToastFaile('Lỗi!');
          } else {
            const message = err.response.data.message;
            makeToastFaile(message);
          }
          this.$nprogress.done();
        });
    },
    validateUpsertContract(contract) {
      let isValid = true;
      const messages = [];
      if (!contract.storeId) {
        isValid = false;
        messages.push('Vui lòng chọn cửa hàng');
      }
      if (!contract.contractDate) {
        isValid = false;
        messages.push('Vui lòng chọn ngày hợp đồng');
      }
      if (!contract.contractNumber) {
        isValid = false;
        messages.push('Vui lòng nhập mã hợp đồng');
      }
      if (!contract.customerName) {
        isValid = false;
        messages.push('Vui lòng nhập tên khách hàng');
      }
      if (!contract.customerPhone) {
        isValid = false;
        messages.push('Vui lòng nhập số điện thoại khách hàng');
      }
      if (!contract.shippingAddress) {
        isValid = false;
        messages.push('Vui lòng địa chỉ giao hàng');
      }
      if (!contract.saleId) {
        isValid = false;
        messages.push('Vui lòng chọn nhân viên bán hàng');
      }
      // 2026-05-13: bỏ require Nhân viên giao hàng theo yêu cầu user. shipperId
      // giờ optional ở cả Đề Nghị + HĐMB. Backend cũng không validate field này.
      if (!contract.paymentType) {
        isValid = false;
        messages.push('Vui lòng chọn loại thanh toán');
      }
      if (contract.totalDiscountAmount < 0) {
        isValid = false;
        messages.push('Chiết khấu phải lớn hơn hoặc bằng 0');
      }

      if (!contract.contractDetail.length) {
        isValid = false;
        messages.push('Vui lòng chọn sản phẩm tạo hợp đồng');
      }

      return [isValid, messages];
    },
    validateUpsertOrder(order) {
      let isValid = true;
      const messages = [];

      if (!order.storeId) {
        isValid = false;
        messages.push('Vui lòng chọn cửa hàng');
      }

      if (!order.orderSourceId) {
        isValid = false;
        messages.push('Vui lòng chọn nguồn đơn hàng');
      }

      if (!order.orderType) {
        isValid = false;
        messages.push('Vui lòng nhập loại đơn hàng');
      }

      if (!order.status) {
        isValid = false;
        messages.push('Vui lòng chọn trạng thái đơn hàng');
      }

      if (
        [
          ORDER_STATUS.UN_SUCCESS,
          ORDER_STATUS.SYSTEM_CANCEL,
          ORDER_STATUS.CR_CANCEL,
        ].includes(Number(order.status)) &&
        !order.cancelStatus
      ) {
        isValid = false;
        messages.push('Vui lòng chọn lý do huỷ');
      }

      if (!order.orderItems.length) {
        isValid = false;
        messages.push('Vui lòng chọn sản phẩm');
      }

      if (!order.customerMobile) {
        isValid = false;
        messages.push('Vui lòng nhập số điện thoại khách hàng');
      }

      if (order.customerMobile && order.customerMobile.length > 12) {
        isValid = false;
        messages.push('Vui lòng nhập số điện thoại < 12 số');
      }

      if (!order.customerAppellation) {
        isValid = false;
        messages.push('Vui lòng nhập danh xưng khách hàng');
      }

      if (!order.customerName || !order.customerName.trim().length) {
        isValid = false;
        messages.push('Vui lòng nhập tên khách hàng');
      }

      if (order.discountAmount > this.totalPriceItem) {
        isValid = false;
        messages.push('Số tiền chiết khấu không nên cao hơn số tiền món hàng');
      }

      if (order.customerShipFee > 100000000) {
        isValid = false;
        messages.push('Phí vận chuyển thu của khách phải nhỏ hơn 100.000.000');
      }

      if (order.isInterestZero && order.orderItems.length > 1) {
        isValid = false;
        messages.push('Chương trình trả góp 0% chỉ áp dụng cho 1 sản phẩm');
      }

      const errorPayments = this.validatePayment(order);

      if (errorPayments.length) {
        isValid = false;
        errorPayments.map((error) => {
          messages.push(error);
        });
      }

      return [isValid, messages];
    },
    validatePayment(billData) {
      const payments = [
        billData.cash,
        billData.transfer,
        billData.credits,
        billData.installments,
        billData.refunds,
      ];
      const errorMessages = payments.flat().reduce((result, item) => {
        if (item && item.paymentAmount > 0 && !item.paymentRefId) {
          result.push(
            `Tài khoản thanh toán số tiền ${convertPrice(
              item.paymentAmount,
            )} không hợp lệ`,
          );
        }
        return result;
      }, []);
      return errorMessages;
    },
    handleOrderItemGet(orderItems) {
      let term = [];
      const itemHandlers = orderItems.map((item) => {
        item.sellingPrice = item.productPrice;
        item.sellingPriceMask = item.productPrice;
        item.discountType = item.discountType || 1;
        item.comboItems = item.productInCombos || [];
        return item;
      });

      const mainItems = itemHandlers.filter(
        (item) => item.orderItemType === ITEM_TYPE.MAIN,
      );

      let count = 1;
      mainItems.map((parent) => {
        const relatedItems = itemHandlers.filter(
          (child) => child.belongOrderDetailId === parent.orderItemId,
        );
        const parentId = this.$uuid.v4();
        parent.id = parentId;
        parent.stt = count;
        term.push(parent);
        relatedItems.map((child) => {
          child.id = this.$uuid.v4();
          child.belongOrderDetailId = parentId;
          term.push(child);
        });
        count++;
      });
      return term;
    },
    getContractDetail: function (id) {
      ApiService.get(`/contract/${id}`).then((response) => {
        const { data } = response.data;
        const { status, message } = response.data;

        if (status) {
          this.orderCampainPhase = data.orderCampainPhase;
          // HĐ KH DN: customerId=null + customerBusinessId=<id> (XOR). Đọc cả 2
          // để các check `customerInfo.customer*Id` ở dưới biết KH đã được link.
          this.customerInfo.customerId = data.customerId;
          this.customerInfo.customerBusinessId = data.customerBusinessId;
          this.customerInfo.customerType = data.customerType;
          this.customerInfo.customerName = data.customerName;
          this.contractInfo = { ...this.contractInfo, ...data };
          // Bug fix: BE trả date ISO; datepicker (CustomerInfoSection) cấu hình
          // 'DD/MM/YYYY' → không hiển thị raw ISO ⇒ tưởng "không lưu". Chuẩn hóa
          // về DD/MM/YYYY (parity với onSelectCustomer). Re-submit cũng cần đúng
          // format vì payload moment(value,'DD/MM/YYYY').
          this.contractInfo.customerCccdDate = data.customerCccdDate
            ? moment(data.customerCccdDate).format('DD/MM/YYYY')
            : null;
          this.contractInfo.customerDob = data.customerDob
            ? moment(data.customerDob).format('DD/MM/YYYY')
            : null;
          // Cùng lý do: DN — Ngày thành lập + Ngày ủy quyền (BE trả ISO).
          this.contractInfo.customerFoundDate = data.customerFoundDate
            ? moment(data.customerFoundDate).format('DD/MM/YYYY')
            : null;
          this.contractInfo.authorizationDate = data.authorizationDate
            ? moment(data.authorizationDate).format('DD/MM/YYYY')
            : null;

          // Fix typo cũ: `saleId = data.storeId` (sai field) → `data.saleId`.
          // Pre-existing bug, sửa tiện trong patch Phase B vì cùng block.
          this.contractEmployeeInfo.saleId = data.saleId;
          this.contractEmployeeInfo.saleName = data.saleName;
          this.contractEmployeeInfo.shipperId = data.shipperId;
          this.contractEmployeeInfo.shipperName = data.shipperName;
          // Phase B — load 4 vai trò NV mở rộng từ contract response.
          this.contractEmployeeInfo.technicalId = data.technicalId;
          this.contractEmployeeInfo.technicalName = data.technicalName;
          this.contractEmployeeInfo.cashierId = data.cashierId;
          this.contractEmployeeInfo.cashierName = data.cashierName;
          this.contractEmployeeInfo.managerId = data.managerId;
          this.contractEmployeeInfo.managerName = data.managerName;
          this.contractEmployeeInfo.assistantId = data.assistantId;
          this.contractEmployeeInfo.assistantName = data.assistantName;
          this.contractInfo.contractDetail = data.contractDetail.flatMap(
            (item) => {
              const mainClientId = this.$uuid.v4();
              const main = {
                ...item,
                _clientId: mainClientId,
                orderItemType: ITEM_TYPE.MAIN,
                productPrice: Number(item.productPrice) || 0,
                sellingPrice: Number(item.productPrice) || 0,
                sellingPriceMask: Number(item.productPrice) || 0,
                discountAmount: Number(item.discountAmount) || 0,
                totalAmount: Number(item.totalAmount) || 0,
                vouchers: item.vouchers || [],
                serialNumber: item['productSerial']
                  ? item['productSerial']['serialNumber']
                  : null,
                engineNumber: item['productChassis']
                  ? item['productChassis']['engineNumber']
                  : null,
                chassisNumber: item['productChassis']
                  ? item['productChassis']['chassisNumber']
                  : null,
              };
              // SP tặng kèm (nested từ BE) → flatten thành dòng riêng gắn parent.
              const gifts = (item.gifts || []).map((g) => ({
                ...g,
                _clientId: this.$uuid.v4(),
                belongOrderClientId: mainClientId,
                orderItemType: ITEM_TYPE.GIFT,
                checked: true,
                deleted: false,
                productPrice: 0,
                sellingPrice: 0,
                sellingPriceMask: 0,
                discountAmount: 0,
                totalAmount: 0,
                quantity: Number(g.quantity) || 1,
                vouchers: [],
                // SP tặng kèm có thể là xe (CHASSIS_ENGINE/SERIES) → cần loại SP
                // (từ relation product) để hiện nút chọn số khung/seri, và hiển
                // thị SK/SM/seri nếu đã phân bổ. (parity với SP bán kèm bên dưới)
                serialNumber: g['productSerial']
                  ? g['productSerial']['serialNumber']
                  : null,
                engineNumber: g['productChassis']
                  ? g['productChassis']['engineNumber']
                  : null,
                chassisNumber: g['productChassis']
                  ? g['productChassis']['chassisNumber']
                  : null,
                product: {
                  type: (g.product && g.product.type) || g.productType || null,
                },
              }));
              // SP bán kèm (nested từ BE) → flatten dòng riêng gắn parent, GIỮ giá.
              const attachs = (item.attachs || []).map((a) => {
                const price = Number(a.productPrice) || 0;
                return {
                  ...a,
                  _clientId: this.$uuid.v4(),
                  belongOrderClientId: mainClientId,
                  orderItemType: ITEM_TYPE.ATTACH,
                  checked: true,
                  deleted: false,
                  productPrice: price,
                  sellingPrice: price,
                  sellingPriceMask: price,
                  discountAmount: Number(a.discountAmount) || 0,
                  discountType: a.discountType || 'AMOUNT',
                  totalAmount: Number(a.totalAmount) || 0,
                  quantity: Number(a.quantity) || 1,
                  vouchers: [],
                  // SP bán kèm có thể là xe (CHASSIS_ENGINE/SERIES) → cần loại SP
                  // (từ relation product) để hiện nút chọn số khung/seri, và hiển
                  // thị SK/SM/seri nếu đã phân bổ.
                  serialNumber: a['productSerial']
                    ? a['productSerial']['serialNumber']
                    : null,
                  engineNumber: a['productChassis']
                    ? a['productChassis']['engineNumber']
                    : null,
                  chassisNumber: a['productChassis']
                    ? a['productChassis']['chassisNumber']
                    : null,
                  product: {
                    type:
                      (a.product && a.product.type) || a.productType || null,
                  },
                };
              });
              return [main, ...gifts, ...attachs];
            },
          );
          this.contractInfo.contractPaymentTerm = data.contractPaymentTerm.map(
            (item) => ({
              ...item,
              fromDate: moment(item['fromDate'])
                .startOf('day')
                .format('DD-MM-YYYY HH:mm:ss'),
              toDate: moment(item['toDate'])
                .endOf('day')
                .format('DD-MM-YYYY HH:mm:ss'),
            }),
          );
          // Đã ra hóa đơn / đã hủy / đã tạo hóa đơn → khóa chỉnh sửa toàn bộ HĐ.
          if (data.bill || ['cancelled', 'invoiced'].includes(data.status)) {
            this.isDisabled = true;
          }
          // this.mappingOrderVuex(data);
          this.loadingComponent = true;
          // Load lịch sử thao tác để stepper hiển thị người duyệt từng bước.
          this.loadContractHistory();
        } else {
          makeToastFaile(message);
        }
      });
    },
    getPreOrderById: async function () {
      ApiService.query(`pre-orders/${this.preOrderId}`).then(
        async (response) => {
          const { data } = response.data;
          const { status } = response.data;
          if (status) {
            if (data.orderId) {
              makeToastFaile(
                `Đơn hàng đặt trước đã được gắn với đơn hàng ${data.orderId}`,
              );
              this.preOrderId = null;
              this.$router.push({
                path: '/orders',
                query: {
                  id: data.orderId,
                },
              });
              return;
            }
            const product = data.product;

            data.orderItems = [];
            if (product) {
              product.productId = product.id;
              product.productPrice = product.sellingPrice;
              product.orderItemType = 1;
              product.quantity = 1;
              product.belongOrderDetailId = null;
              product.isPrivateNote = false;
              product.popPrivateNote = '';
              data.orderItems = [product];
            }
            data.orderSourceId = 756139;
            data.orderSourceName = 'Pre-Order';
            data.saleNote = data.notes ? data.notes : '';

            // TODO chỉnh lại cho pre -order
            data.installedMoneyAmount = data.installMoneyAmount || 0;
            data.installMoneyAccountId =
              Number(data.installMoneyAccountId) || null;
            data.installmentCode = data.installMoneyCode;
            data.installMoneyAccountName = data.installmentMoneyAccountName;
            data.preOrderId = this.preOrderId;
            data.status = 3;

            this.mappingOrderVuex(data);
          }
        },
      );
    },
    onReceivePayment(paymentInfo) {
      this.orderPayment = paymentInfo;
    },
    onReceivePaymentMul(items = [], type) {
      const payments = items.reduce((result, current) => {
        result.push({
          ...current,
          paymentAmount: unMaskPrice(current.paymentAmount) || 0,
        });
        return result;
      }, []);
      const sumAmount = (items) => {
        return items.reduce((result, item) => {
          return result + Number(item.paymentAmount);
        }, 0);
      };
      switch (type) {
        case PAYMENT_TYPE.INSTALLMENT: {
          this.orderPayment.installments = payments;
          this.orderPayment.installedMoneyAmount = sumAmount(payments);
          break;
        }
        case PAYMENT_TYPE.CREDIT: {
          this.orderPayment.credits = payments;
          this.orderPayment.creditAmount = sumAmount(payments);
          break;
        }
        case PAYMENT_TYPE.TRANSFER: {
          this.orderPayment.transfer = payments;
          this.orderPayment.transferAmount = sumAmount(payments);
          this.transferAmount = this.orderPayment.transferAmount;
          break;
        }
        case PAYMENT_TYPE.CASH: {
          this.orderPayment.cash = payments;
          this.orderPayment.depositAmount = sumAmount(payments);
          break;
        }
        case PAYMENT_TYPE.REFUND: {
          this.orderPayment.refunds = payments;
          this.orderPayment.refundAmount = sumAmount(payments);
          break;
        }
      }
    },
    onCloseOrder() {
      if (this.fromModal) {
        this.$bvModal.hide('md-edit-order');
      } else {
        this.$router.go(-1);
      }
    },
    onContinueCreateOrder() {
      this.footSetting.continue = true;
      this.upsertOrder();
    },
    settingFooter() {
      this.$router.push({
        path: '/orders',
      });
    },
    onShowInterestProgram() {
      this.$refs['bill-payment'].onLoading.interestZero = true;
      this.$nextTick(() => {
        EventBus.$emit('popup-insterest-program');
      });
    },
  },
};
</script>
<style lang="scss">
.upsert-order {
  // Sprint 3 — linked request banner + legal snapshot
  .cr-linked-request {
    color: #3699ff;
    font-weight: 600;
    text-decoration: underline;
    cursor: pointer;
    margin-left: 4px;

    i {
      font-size: 11px;
    }

    &:hover {
      opacity: 0.85;
    }
  }
  // Lý do hủy HĐ — icon trong b-alert danger phải kế thừa màu đỏ của alert,
  // KHÔNG bị Metronic global `i{color:...}` đè (frontend-styling.md rule #1).
  .cr-cancel-reason {
    i {
      color: inherit !important;
    }
  }
  // Ghi chú gỡ phân bổ — icon trong b-alert info phải kế thừa màu xanh của alert,
  // KHÔNG bị Metronic global `i{color:...}` đè (frontend-styling.md rule #1).
  .cr-unallocate-note {
    i {
      color: inherit !important;
    }
  }
  // Luồng duyệt HĐMB — stepper 9 bước
  .contract-stepper {
    display: flex;
    align-items: flex-start;
    gap: 0;
    overflow-x: auto;
    padding: 4px 0 2px;

    .contract-step {
      flex: 1 1 0;
      min-width: 78px;
      text-align: center;
      position: relative;

      // đường nối giữa các bước — chốt ở đúng tâm dọc của dot:
      // dot box-sizing border-box, height 26px → tâm = 13px; line dày 2px nên top = 12px.
      &:not(:first-child)::before {
        content: '';
        position: absolute;
        top: 12px;
        left: -50%;
        width: 100%;
        height: 2px;
        background: #e5eaee;
        z-index: 0;
        pointer-events: none;
      }

      .contract-step-dot {
        position: relative;
        z-index: 2;
        // ép box-sizing + kích thước cố định để dot luôn 26x26 dù global CSS (Bootstrap/Metronic)
        // có set box-sizing border-box hay đè kích thước — giữ đường nối thẳng hàng tâm dot.
        box-sizing: border-box !important;
        width: 26px !important;
        height: 26px !important;
        min-width: 26px;
        line-height: 22px !important;
        padding: 0 !important;
        border-radius: 50%;
        margin: 0 auto;
        background: #fff;
        border: 2px solid #e5eaee;
        color: #b5b5c3;
        font-size: 12px;
        font-weight: 700;
        overflow: hidden;

        // icon FontAwesome bên trong bị global CSS (Metronic) ép màu xám → ép kế thừa màu của dot;
        // đồng thời ép cỡ icon nhỏ gọn trong dot, không phình to làm lệch layout.
        i,
        svg {
          color: inherit !important;
          font-size: 12px !important;
          line-height: 1 !important;
          width: auto !important;
          height: auto !important;
          vertical-align: baseline !important;
        }
      }

      // label & actor luôn nằm DƯỚI dot + đường nối, và phải vẽ ĐÈ LÊN mọi đường nối
      // (đường nối z-index:0, label z-index:3) — kể cả khi connector của bước sau tràn sang.
      .contract-step-label {
        position: relative;
        z-index: 3;
        margin-top: 4px;
        font-size: 11px;
        color: #b5b5c3;
        line-height: 1.2;
        // chừa đủ chỗ cho nhãn 2 dòng để các cột thẳng hàng nhau (vd "Đã tạo hóa đơn" wrap)
        min-height: calc(11px * 1.2 * 2);
      }

      .contract-step-actor {
        position: relative;
        z-index: 3;
        margin-top: 2px;
        font-size: 10px;
        color: #b5b5c3;
        line-height: 1.15;
        padding: 0 2px;
      }

      &.is-done {
        .contract-step-dot {
          background: #1bc5bd;
          border-color: #1bc5bd;
          color: #fff;
        }
        .contract-step-label {
          color: #3f4254;
        }
        .contract-step-actor {
          color: #7e8299;
        }
        &:not(:first-child)::before {
          background: #1bc5bd;
        }
      }

      &.is-current {
        .contract-step-dot {
          background: #3699ff;
          border-color: #3699ff;
          color: #fff;
          box-shadow: 0 0 0 4px rgba(54, 153, 255, 0.15);
        }
        .contract-step-label {
          color: #3699ff;
          font-weight: 700;
        }
        .contract-step-actor {
          color: #7e8299;
        }
        // Đường nối DẪN VÀO bước hiện tại: gradient từ màu "đã hoàn thành" (teal) sang màu
        // "bước hiện tại" (blue) → chuyển màu mượt, ăn nhập với dot xanh dương phía cuối thay vì
        // bị cấn teal đập thẳng vào dot xanh. Các đoạn SAU bước hiện tại vẫn xám.
        &:not(:first-child)::before {
          background: linear-gradient(90deg, #1bc5bd 0%, #3699ff 100%);
        }
      }

      &.is-cancelled-step {
        // Chỉ icon X (dot) màu đỏ; đường nối tới node "Đã hủy" giữ màu xám như các bước khác.
        .contract-step-dot {
          background: #f64e60;
          border-color: #f64e60;
          color: #fff;
        }
        .contract-step-label {
          color: #f64e60;
          font-weight: 700;
        }
      }
    }

    // Khi HĐ bị hủy → làm mờ các bước trước. KHÔNG đặt `opacity` lên `.contract-step`
    // (sẽ tạo stacking context, khiến connector đỏ của node "Đã hủy" — vốn tràn sang nửa trái —
    // vẽ ĐÈ lên dot/label của bước trước). Mờ từng phần tử con để không sinh stacking context.
    &.is-cancelled .contract-step:not(.is-cancelled-step) {
      .contract-step-dot,
      .contract-step-label,
      .contract-step-actor,
      &::before {
        opacity: 0.55;
      }
    }
  }
  .legal-snapshot-card {
    border: 1px solid #e5eaee;
  }
  .legal-snapshot-toggle {
    cursor: pointer;
    user-select: none;

    &:hover {
      opacity: 0.85;
    }
  }

  .relative {
    position: relative;
  }
  #input-discount {
    padding-left: 35%;
    border: 1px solid #ced4da;
  }
  .absolute {
    top: 9px;
    left: 4%;
    font-size: 0.74vw;
    position: absolute;
  }

  .vue-treeselect__input-container {
    padding-top: 0px;
  }

  .vue-treeselect__control {
    border-radius: 0.28rem;
    border: 1px solid #ced4da;
    height: 2.5rem;
  }

  .vue-treeselect--has-value .vue-treeselect__multi-value {
    margin-bottom: 2px;
  }

  .wizard.wizard-4 .wizard-nav .wizard-steps .wizard-step {
    flex: 0 0 calc(15% - 0.25rem);
  }

  @media (max-width: 1399.98px) {
    .wizard.wizard-4 .wizard-nav .wizard-steps .wizard-step {
      flex: 0 0 calc(17% - 0.25rem);
    }
  }

  .wizard-nav-bg {
    // background-color: #eef0f8;
    // border-radius: 4px 4px 0px 0px;
    background-color: #f7f7f7;
    border-radius: 5px 5px 0px 0px;
  }

  .btn-config .btn {
    padding: 0.4rem 0.4rem;
  }
  .card-footer {
    padding: 1rem 2.25rem;
  }
  .form-group {
    margin-bottom: 1rem;
  }
}
</style>
<style>
.autosuggest__results ul {
  list-style: none;
  cursor: pointer;
  margin-bottom: 0;
}

.autosuggest__results {
  position: absolute;
  background-color: #fff;
  z-index: 1;
  width: 100%;
  border: 1px solid #e0e0e0;
  overflow: scroll;
  max-height: 200px;
  position: absolute;
}

.autosuggest__results-container {
  position: relative;
  width: 100%;
  z-index: 10000001;
  font-weight: 500;
  background: white;
}

#autosuggest__input {
  display: block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition:
    border-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out;
  height: calc(1.35em + 1.1rem + 2px);
  padding: 0.55rem 0.75rem;
  font-size: 0.925rem;
  line-height: 1.35;
  border-radius: 0.28rem;
}

#autosuggest__input:focus {
  outline: none !important;
  border: 1px solid #92c5f9;
}

.autosuggest__results-item:hover {
  background-color: #ddd;
}

.autosuggest__results ul li {
  padding: 8px;
}

.alert-warning {
  color: #855700;
  background-color: #ffeecc;
  border-color: #ffe7b8;
}
</style>
<style lang="scss">
@import '@/assets/sass/pages/wizard/wizard-4.scss';
</style>
